import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import {
    Box,
    Drawer,
    Divider,
    TextField,
    Grid,
    Button,
    IconButton,
    Menu,
    useTheme,
    styled,
    Toolbar,
    CssBaseline,
    Switch,
    Typography,
    Tooltip,
    MenuItem,
    Modal,
} from '@mui/material';
import { Call, RemoveRedEye, LocalPhone, PhoneDisabled, RingVolume, PermIdentity, Keyboard, NoteAlt, PeopleOutline, Mic, MicOff, Redo, Pause, PlayArrow, Cancel, VolumeOff, VolumeUp } from '@mui/icons-material';
import BackspaceIcon from '@mui/icons-material/Backspace';
import AddIcon from '@mui/icons-material/Add';
import {
    UserAgent,
    Inviter,
    SessionState,
    Registerer,
    RegistererState,
} from 'sip.js';
import axios from 'axios';
import { global_link, socket_base_url, socketiopath, audio_socket_base_url, audio_socket_path } from './Globallink';
import { useTimer } from './Timer';
import modalStyle from './ModalStyle';
import { io } from 'socket.io-client';
import WebSocketContext from '../Context/WebSocket';
import { jwtDecode } from 'jwt-decode';


const DialBar = ({ onClose, children }) => {
    const api = axios.create({ baseURL: global_link });
    const authToken = process.env.AUTH_TOKEN;
    const authyToken = localStorage.getItem(authToken);
    const [searchText, setSearchText] = useState('');
    const [dialdisplay, setDialDisplay] = useState('');
    const [selectedDailerTab, setSelectedDailerTab] = useState(0);
    const [hideCallButtonsAccept, setHideCallButtonsAccept] = useState(true);
    const [showConnecting, setShowConnecting] = useState('');
    const [transferExtension, setTransferExtension] = useState('');
    const [transferToUsers, setTransferToUsers] = useState([]);
    const [externalDisplay, setExternalDisplay] = useState('');
    const [externalAttendedDisplay, setExternalAttendedDisplay] = useState('');

    // Warm Transfer
    const [consultationSession, setConsultationSession] = useState(null);
    const [isInWarmTransfer, setIsInWarmTransfer] = useState(false);
    const [warmTransferTarget, setWarmTransferTarget] = useState('');
    const [isConsultationReady, setIsConsultationReady] = useState(false);
    const [unattendedInternalStatus, setUnattendedInternalStatus] = useState(false);

    // ── 3-Party Conference (browser-mixed, no FreeSWITCH bridge) ───────────────
    const [conferencePanel, setConferencePanel] = useState(false);   // dial panel open
    const [conferenceDisplay, setConferenceDisplay] = useState('');  // number being dialed for conf
    const [conferenceStatus, setConferenceStatus] = useState('');    // human-readable status line
    const [isConfDialing, setIsConfDialing] = useState(false);       // child leg ringing
    const [isConfReady, setIsConfReady] = useState(false);           // child leg established, awaiting merge
    const [isConfJoined, setIsConfJoined] = useState(false);         // all three parties merged

    // The second SIP leg (agent <-> third party). Independent of the parent call.
    const conferenceSessionRef = useRef(null);
    // Pristine mic tracks captured BEFORE any mixed track is swapped in, one per
    // peer connection. Restored on teardown so senders return to raw mic audio.
    const parentMicTrackRef = useRef(null);  // parent PC's original outgoing mic track
    const confMicTrackRef = useRef(null);    // child PC's original outgoing mic track
    // AudioContexts created for the two mixers — closed on teardown to free HW.
    const mixCtxRefs = useRef([]);
    // Guard so teardown can only run once even if multiple end-events race.
    const confTeardownGuardRef = useRef(false);

    // Mirror mute/hold into refs so promise callbacks (post replaceTrack) read
    // the CURRENT value, not a value captured at closure-creation time.
    const isMutedRef = useRef(false);
    const isHeldRef = useRef(false);

    // DIALER STATE CHANGES
    const [displayInput, setDisplayInput] = useState(true);
    const [dialerButtons, setDialerButtons] = useState(true);
    const [showIncomingCall, setShowIncomingCall] = useState(false);
    const [isRinging, setRinging] = useState('MAKING CALL');
    const [showMakingCall, setMakingCall] = useState(false);
    const [showacceptedCall, setAcceptedCall] = useState(false);
    const { timer, startTimer, resetTimer, getCurrentTimer } = useTimer();
    const [dialerNumber, setDialerNumber] = useState('');
    const [contactName, setContactName] = useState('');
    // Phone associated with the live lookup result — used when the user clicks the name
    const [matchedContactPhone, setMatchedContactPhone] = useState('');
    // Multiple dialer search hits (same name / several numbers) — each row is tappable
    const [contactMatches, setContactMatches] = useState([]);
    const [dtmfButtons, setDtmfButtons] = useState(false);
    const [incomingNumber, setIncomingNumber] = useState('');
    const [dTMFValue, setDTMFValue] = useState('');
    const [transferCalls, setTransferCalls] = useState(false);
    const [externalTransferCalls, setExternalTransferCalls] = useState(false);
    const [externalAttendedTransferCalls, setExternalAttendedTransferCalls] = useState(false);
    const [transferSelection, setTransferSelection] = useState(false);
    const [transferSelectionValue, setTransferSelectionValue] = useState('');
    const [dispositionList, setDispositionList] = useState([]);
    const [newDisposition, setNewDisposition] = useState({
        user_name: '',
        disposition_contact: '',
        disposition: '',
        disposition_info: '',
        call_type: '',
        disposition_time: '',
    });
    const [openAddDispositionModal, setAddDispositionModal] = useState(false);
    const [dispositionHangupButton, setDispositionHangupButton] = useState('none');
    const [callType, setCallType] = useState('');
    const [callTypeCallLog, setCallTypeCallLog] = useState('');
    const [dispositionContact, setDispositionContact] = useState('');
    const [callLogDuration, setCallLogDuration] = useState('');

    const [activeTransferButton, setActiveTransferButton] = useState(null);

    // Auto Dialer States
    const [campaignMode, setCampaignMode] = useState(false);
    const [campaignContacts, setCampaignContacts] = useState([]);
    const [currentContactIndex, setCurrentContactIndex] = useState(0);
    const [campaignTimeout, setCampaignTimeout] = useState(30);
    const campaignTimeoutRef = useRef(null);
    const [flashSwitch, setFlashSwitch] = useState(false);

    // State Management
    const [voipSignalStatus, setVoipSignalStatus] = useState('#FF160C');
    const [registered, setRegistered] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isHeld, setIsHeld] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState('disconnected');
    const userAgentRef = useRef(null);
    const registererRef = useRef(null);
    const registrationTimeoutRef = useRef(null);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const connectivityCheckIntervalRef = useRef(null);
    const statusCheckIntervalRef = useRef(null);
    const [acceptCallHandler, setAcceptCallHandler] = useState(null);
    const [rejectCallHandler, setRejectCallHandler] = useState(null);
    const [openTakingBreakModal, setTakingBreakOpen] = useState(false);
    const [dispositionCategory, setDispositionCategory] = useState([]);
    const [subCategorDataDropDown, setSubCategorDataDropDown] = useState([]);

    const remoteAudioRef = useRef(null);
    const localAudioRef = useRef(null);
    const dialedNumberRef = useRef(null);

    const [callEnabled, setCallEnabled] = useState(true);
    const [takeBreak, setTakeBreak] = useState(false);
    const [autoAnswer, setAutoAnswer] = useState(false);
    const [isRingtoneMuted, setIsRingtoneMuted] = useState(false);
    const [RingtoneIcon, setRingtoneIcon] = useState(true);

    const callEnabledRef = useRef(callEnabled);
    const takeBreakRef = useRef(takeBreak);
    const autoAnswerRef = useRef(autoAnswer);

    const incomingCallSessionRef = useRef(null);
    const outgoingCallSessionRef = useRef(null);
    const activeCallSessionRef = useRef(null);
    const recording_call_id = useRef(null);
    const [breakType, setBreakType] = useState('');
    const [breakDrop, setBreakDrop] = useState('');
    const [breakBtn, setBreakBtn] = useState('none');

    const outgoingToneRef = useRef(new Audio('/Tones/dial_call.mp3'));
    const endcallToneRef = useRef(new Audio('/Tones/end_call.mp3'));
    const incomingRingtoneRef = useRef(new Audio('/Tones/ringtone_2.mp3'));
    const socketRef = useRef(null);

    // ONLINE PRESENCE
    const { socket, user_id } = useContext(WebSocketContext);
    const [onlineUsers, setOnlineUsers] = useState(new Set());

    // AudioContext stored in ref so it can be closed on cleanup
    const audioCtxRef = useRef(null);
    // mediaRecorder and recordedChunks in refs
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);

    // [RECORD] The mixer destination + context for the SAVE recorder. Kept in
    // refs so the conference merge can splice party2's audio into the same
    // recording graph without rebuilding the recorder.
    const recordCtxRef = useRef(null);
    const recordRemotePannerRef = useRef(null); // party1 (right channel) sink node
    const confRecordSourceRef = useRef(null);   // party2 source node, added on merge

    // [AUDIO] Dedicated audio socket ref — separate from signaling socket
    const audioSocketRef = useRef(null);
    // [AUDIO] Live stream recorder ref (separate from save recorder)
    const streamRecorderRef = useRef(null);
    // [AUDIO] Source stream for the live relay — kept so the relay recorder can
    // be RESTARTED mid-call when a supervisor joins the listen room. A restart
    // produces a fresh WebM header + timeline, which is what makes 2nd/3rd/nth
    // listen sessions work.
    const liveStreamDestRef = useRef(null);

    // [AUDIO] Session token to prevent stale chunks from an old recorder
    const liveRelaySessionRef = useRef(null);

    // Whisper chunk buffering refs
    const whisperChunkBufferRef = useRef([]);
    const whisperMetadataRef = useRef(null);
    const whisperDecodeTimeoutRef = useRef(null);
    const whisperAudioCtxRef = useRef(null);
    const whisperGainNodeRef = useRef(null);

    // Whisper MSE streaming refs (production-ready)
    const whisperMediaSourceRef = useRef(null);
    const whisperSourceBufferRef = useRef(null);
    const whisperAudioElementRef = useRef(null);
    const whisperChunkQueueRef = useRef([]);
    const whisperMseReadyRef = useRef(false);
    const whisperMimeTypeRef = useRef('audio/webm; codecs=opus');

    // ── ICE connection recovery ───────────────────────────────────────────────
    const iceRecoveryTimerRef = useRef(null);

    const drawerWidth = 240;
    const openRight = true;
    const theme = useTheme();

    const campaignModeRef = useRef(false);
    const campaignContactsRef = useRef([]);
    const currentContactIndexRef = useRef(0);
    // Hard latch: set true the moment the list is exhausted so any late/racing
    // end-event (duplicate Terminated + onReject, a stale no-answer timeout, etc.)
    // can't re-enter dialNextContact and re-dial the final contact.
    const campaignDoneRef = useRef(false);

    // ── Per-call log/advance guard ────────────────────────────────────────────
    const callLoggedRef = useRef({ done: true, advanced: true });
    const incomingCallLoggedRef = useRef(false);

    // ── Outgoing call "was it ever picked up" guard ─────────────────────────────
    const callEstablishedRef = useRef(false);

    // ── Tone helpers ──────────────────────────────────────────────────────────
    const stopIncomingTone = () => {
        incomingRingtoneRef.current.pause();
        incomingRingtoneRef.current.currentTime = 0;
    };
    const stopOutgoingTone = () => {
        outgoingToneRef.current.pause();
        outgoingToneRef.current.currentTime = 0;
    };
    const stopEndTone = () => {
        endcallToneRef.current.pause();
        endcallToneRef.current.currentTime = 0;
    };
    const playOutgoingTone = () => {
        outgoingToneRef.current.play();
        outgoingToneRef.current.loop = true;
    };
    const playEndTone = () => {
        stopIncomingTone();
        stopOutgoingTone();
        setTimeout(() => {
            if (endcallToneRef.current) {
                endcallToneRef.current.currentTime = 0;
                endcallToneRef.current.play().catch(error => {
                    console.log('Error playing end tone:', error);
                });
            }
        }, 50);
    };
    const playIncomingTone = () => {
        incomingRingtoneRef.current.play();
        incomingRingtoneRef.current.loop = true;
    };

    const handleCallEnableChange = (event) => {
        if (!activeCallSessionRef.current) {
            const newValue = event.target.checked;
            setCallEnabled(newValue);
            callEnabledRef.current = newValue;
            localStorage.setItem('callEnabled', JSON.stringify(newValue));
        }
    };

    // ── Signaling socket init ─────────────────────────────────────────────────
    useEffect(() => {
        const token = localStorage.getItem(authToken);
        socketRef.current = io(socket_base_url, {
            socketiopath,
            auth: { token },
            transports: ['websocket'],
        });
        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    // ── Drain queued chunks into SourceBuffer ──────────────────────────────
    const drainWhisperQueue = useCallback(() => {
        const sb = whisperSourceBufferRef.current;
        if (!sb || sb.updating || whisperChunkQueueRef.current.length === 0 || !whisperMseReadyRef.current) {
            return;
        }

        // --- Low Latency: Prevent whisper buffer from growing too large ---
        try {
            if (sb.buffered.length > 0 && !sb.updating) {
                const audio = whisperAudioElementRef.current;
                const currentTime = audio?.currentTime || 0;
                const bufferedEnd = sb.buffered.end(sb.buffered.length - 1);
                // If we have more than 1.5 seconds of audio buffered, drop the old stuff
                if (bufferedEnd - currentTime > 1.5) {
                    sb.remove(0, bufferedEnd - 1.0);
                    return; // Wait for remove to finish before appending
                }
            }
        } catch (e) {}
        // --------------------------------------------------------------------

        try {
            const nextChunk = whisperChunkQueueRef.current.shift();
            if (nextChunk?.byteLength > 0) {
                sb.appendBuffer(nextChunk);
            }
        } catch (err) {
            console.warn('[Whisper] SourceBuffer append error:', err.name, err.message);
            if (err.name === 'QuotaExceededError') {
                console.warn('[Whisper] SourceBuffer quota exceeded - clearing queue');
                whisperChunkQueueRef.current = [];
            }
        }
    }, []);

    // ── Teardown whisper MSE pipeline ──────────────────────────────────────
    const teardownWhisperMSE = useCallback(() => {
        whisperMseReadyRef.current = false;
        whisperChunkQueueRef.current = [];

        const sb = whisperSourceBufferRef.current;
        if (sb) {
            try { if (sb.updating) sb.abort(); } catch (_) {}
            whisperSourceBufferRef.current = null;
        }

        const ms = whisperMediaSourceRef.current;
        if (ms) {
            try { if (ms.readyState === 'open') ms.endOfStream(); } catch (_) {}
            whisperMediaSourceRef.current = null;
        }

        const audio = whisperAudioElementRef.current;
        if (audio) {
            audio.pause();
            // FIX: capture the blob URL BEFORE clearing src, otherwise the
            // revoke check always sees an empty string and the URL leaks.
            const oldSrc = audio.src;
            audio.src = '';
            try { if (oldSrc?.startsWith('blob:')) URL.revokeObjectURL(oldSrc); } catch (_) {}
            whisperAudioElementRef.current = null;
        }
        console.log('[Whisper] MSE pipeline torn down');
    }, []);

    // ── [AUDIO] Start (or RESTART) the live relay recorder ─────────────────
    // Called when a call starts AND whenever the relay server sends
    // REQUEST_CHUNK_RESEND (i.e. a supervisor joined the listen room). Each
    // (re)start creates a brand-new MediaRecorder on the same mixed stream,
    // which emits a fresh WebM header and a timeline starting at 0 — exactly
    // what the supervisor's MSE pipeline needs to begin playback.
    const startLiveRelay = useCallback((callId) => {
        const stream = liveStreamDestRef.current;
        if (!callId || !stream || !audioSocketRef.current?.connected) {
            console.warn('[Audio] Cannot start live relay — stream:', !!stream,
                'socket:', audioSocketRef.current?.connected, 'callId:', callId);
            return;
        }

        // Stop any existing relay recorder first — a MediaRecorder cannot be
        // restarted after stop(), so a new instance is created each time.
        if (streamRecorderRef.current && streamRecorderRef.current.state !== 'inactive') {
            try { streamRecorderRef.current.stop(); } catch (e) {}
        }
        streamRecorderRef.current = null;

        // ✅ FIX: session token prevents stale chunks from old recorder
        const sessionToken = Date.now();
        liveRelaySessionRef.current = sessionToken;

        let selectedMimeType = 'audio/webm; codecs=opus';
        if (!MediaRecorder.isTypeSupported(selectedMimeType)) {
            console.warn('[Audio] MIME type not supported:', selectedMimeType);
            if (MediaRecorder.isTypeSupported('audio/webm')) {
                selectedMimeType = 'audio/webm';
                console.log('[Audio] Using fallback MIME: audio/webm');
            } else {
                console.error('[Audio] No supported MIME type for live relay');
                return;
            }
        }

        const liveRecorder = new MediaRecorder(stream, {
            mimeType: selectedMimeType,
            audioBitsPerSecond: 32000,
        });

        let headerSent = false;
        let chunkIndex = 0;

        liveRecorder.ondataavailable = async (e) => {
            // ✅ FIX: Drop chunks from a stale recorder session
            if (liveRelaySessionRef.current !== sessionToken) return;

            if (e.data.size < 10) return;
            try {
                const buf = await e.data.arrayBuffer();
                const isHeader = !headerSent;
                if (isHeader) headerSent = true;
                chunkIndex++;

                audioSocketRef.current?.emit('AUDIO_CHUNK', {
                    callId,
                    chunk: buf,
                    isHeader,
                    mimeType: selectedMimeType,
                    chunkIndex,
                });
            } catch (err) {
                console.error('[Dialbar] Error sending audio chunk:', err);
            }
        };

        liveRecorder.onerror = (e) => console.error('[Audio] Live recorder error:', e.error);
        liveRecorder.onstop = () => console.log('[Audio] Live relay recorder stopped for call:', callId);

        streamRecorderRef.current = liveRecorder;
        // 200ms chunks for low-latency streaming to the supervisor
        liveRecorder.start(200);
        console.log('[Audio] Live relay recorder started (200ms chunks) for call:', callId);
    }, []);

    // [AUDIO] Audio socket init — connects to dedicated audio relay server
    useEffect(() => {
        const token = localStorage.getItem(authToken);

        audioSocketRef.current = io(audio_socket_base_url, {
            path: audio_socket_path,
            auth: { token },
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
        });

        audioSocketRef.current.on('connect', () => {
            console.log('[Audio] Connected to audio relay');
            // Only re-register if we actually have an active call session
            if (recording_call_id.current && activeCallSessionRef.current) {
                console.log('[Audio] Re-registering call on reconnect:', recording_call_id.current);
                audioSocketRef.current.emit('REGISTER_CALL', { callId: recording_call_id.current });
                // Restart relay so any listening supervisor gets a fresh stream
                if (liveStreamDestRef.current) {
                    startLiveRelay(recording_call_id.current);
                }
            }
        });

        audioSocketRef.current.on('disconnect', (reason) => {
            console.warn('[Audio] Disconnected from audio relay:', reason);
            teardownWhisperMSE();
        });

        // ── [AUDIO] Supervisor joined the listen room — restart the relay so
        // they receive a fresh WebM header + timeline. THIS is the fix for
        // "listen works the first time but not the second".
        audioSocketRef.current.on('REQUEST_CHUNK_RESEND', ({ callId }) => {
            console.log('[Audio] 🔄 Fresh stream requested by relay for call:', callId);
            console.log('[Audio] 📋 recording_call_id:', recording_call_id.current);
            console.log('[Audio] 📋 Stream available:', !!liveStreamDestRef.current);

            // ✅ FIX: trim both sides to prevent mismatch from SIP header whitespace
            if (String(callId).trim() === String(recording_call_id.current).trim() && liveStreamDestRef.current) {
                startLiveRelay(recording_call_id.current);
            } else {
                console.warn('[Audio] Resend requested for unknown/ended call:', callId, '— expected:', recording_call_id.current);
            }
        });

        // ── WHISPER CHUNK: MSE-based streaming receiver ─────────────────────
        audioSocketRef.current.on('WHISPER_CHUNK', async ({ chunk, isHeader, mimeType, chunkIndex }) => {
            try {
                if (!whisperAudioCtxRef.current) {
                    // Use interactive latency hint for lower delay
                    whisperAudioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' });
                }
                const ctx = whisperAudioCtxRef.current;
                if (ctx.state === 'suspended') await ctx.resume();

                const buf = chunk instanceof ArrayBuffer ? chunk :
                        ArrayBuffer.isView(chunk) ? chunk.buffer.slice(chunk.byteOffset, chunk.byteOffset + chunk.byteLength) :
                        new Uint8Array(Object.values(chunk)).buffer;

                if (isHeader) {
                    // Every whisper session starts with a header (the supervisor
                    // creates a new MediaRecorder per toggle) — tear down any
                    // previous pipeline and rebuild fresh. This makes the 2nd,
                    // 3rd, nth whisper work exactly like the first.
                    console.log('[Whisper] Header received - initializing MSE pipeline');
                    teardownWhisperMSE();

                    const mimeToUse = mimeType || 'audio/webm; codecs=opus';
                    if (!MediaSource.isTypeSupported(mimeToUse)) {
                        const fallbacks = ['audio/webm', 'audio/mp4; codecs=mp4a.40.2', 'audio/mp4'];
                        let found = false;
                        for (const fb of fallbacks) {
                            if (MediaSource.isTypeSupported(fb)) {
                                whisperMimeTypeRef.current = fb;
                                found = true;
                                break;
                            }
                        }
                        if (!found) return;
                    } else {
                        whisperMimeTypeRef.current = mimeToUse;
                    }

                    const ms = new MediaSource();
                    const audio = new Audio();
                    audio.autoplay = true;
                    audio.preload = 'auto';

                    whisperMediaSourceRef.current = ms;
                    whisperAudioElementRef.current = audio;

                    const onSourceOpen = () => {
                        try {
                            const mime = whisperMimeTypeRef.current;
                            const sb = ms.addSourceBuffer(mime);
                            whisperSourceBufferRef.current = sb;
                            sb.mode = 'segments';

                            if (!whisperGainNodeRef.current) {
                                whisperGainNodeRef.current = ctx.createGain();
                                whisperGainNodeRef.current.gain.value = 0.8;
                                whisperGainNodeRef.current.connect(ctx.destination);
                            }

                            try {
                                const srcNode = ctx.createMediaElementSource(audio);
                                srcNode.connect(whisperGainNodeRef.current);
                            } catch (e) {}

                            const playAudio = async () => {
                                try { await audio.play(); } catch (err) {}
                                document.removeEventListener('click', playAudio);
                                document.removeEventListener('touchstart', playAudio);
                            };
                            document.addEventListener('click', playAudio, { once: true, passive: true });
                            document.addEventListener('touchstart', playAudio, { once: true, passive: true });

                            if (buf.byteLength > 0) sb.appendBuffer(buf);
                            sb.addEventListener('updateend', drainWhisperQueue);
                            sb.addEventListener('error', (e) => {
                                whisperChunkQueueRef.current = [];
                            });

                            whisperMseReadyRef.current = true;
                        } catch (err) {
                            teardownWhisperMSE();
                        }
                    };

                    ms.addEventListener('sourceopen', onSourceOpen, { once: true });
                    audio.src = URL.createObjectURL(ms);
                    audio.play().catch(err => {});
                    return;
                }

                if (!whisperMseReadyRef.current || !whisperSourceBufferRef.current) {
                    whisperChunkQueueRef.current.push(buf);
                    return;
                }

                whisperChunkQueueRef.current.push(buf);
                drainWhisperQueue();

            } catch (err) {
                console.error('[Whisper] Error processing chunk:', err);
            }
        });

        audioSocketRef.current.on('WHISPER_RESYNC_REQUEST', ({ callId }) => {
            console.log('[Whisper] Resync requested for call:', callId);
        });

        return () => {
            audioSocketRef.current?.off('connect');
            audioSocketRef.current?.off('disconnect');
            audioSocketRef.current?.off('REQUEST_CHUNK_RESEND');
            audioSocketRef.current?.off('WHISPER_CHUNK');
            audioSocketRef.current?.off('WHISPER_RESYNC_REQUEST');

            teardownWhisperMSE();

            if (whisperAudioCtxRef.current?.state !== 'closed') {
                whisperAudioCtxRef.current?.close();
                whisperAudioCtxRef.current = null;
            }

            audioSocketRef.current?.disconnect();
        };
    }, [authToken, teardownWhisperMSE, drainWhisperQueue, startLiveRelay]);

    const handleTakeBreakChange = ({ target: { checked: newValue } }) => {
        if (activeCallSessionRef.current) return;
        setTakeBreak(newValue);
        takeBreakRef.current = newValue;
        setTakingBreakOpen(newValue);
        function randomBreakString(length = 10) {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        }
        sessionStorage.setItem('break', randomBreakString());
        if (newValue === false) {
            setAutoAnswer(false);
            autoAnswerRef.current = false;
            resetTime();
        } else {
            startTime();
        }
    };

    const handleAutoAnswerChange = (event) => {
        if (takeBreak) {
            setAutoAnswer(false);
            autoAnswerRef.current = false;
            return;
        }
        const newValue = event.target.checked;
        setAutoAnswer(newValue);
        autoAnswerRef.current = newValue;
    };

    // Keep refs in lockstep with mute/hold state for stale-free reads inside
    // async replaceTrack callbacks.
    useEffect(() => { isMutedRef.current = isMuted; }, [isMuted]);
    useEffect(() => { isHeldRef.current = isHeld; }, [isHeld]);

    useEffect(() => {
        const savedCallEnabledValue = localStorage.getItem('callEnabled');
        if (savedCallEnabledValue !== null) {
            const initialValue = JSON.parse(savedCallEnabledValue);
            setCallEnabled(initialValue);
            callEnabledRef.current = initialValue;
        }
    }, []);

    // Shaking Incoming Call Icon
    const ShakingRingVolumeIcon = styled(RingVolume)`
        animation: shake 0.9s linear infinite;
        transform-origin: center;
        @keyframes shake {
            0%   { transform: rotate(0deg); }
            10%  { transform: rotate(20deg); }
            20%  { transform: rotate(-20deg); }
            30%  { transform: rotate(10deg); }
            40%  { transform: rotate(-10deg); }
            50%  { transform: rotate(5deg); }
            60%  { transform: rotate(-5deg); }
            70%  { transform: rotate(2.5deg); }
            80%  { transform: rotate(-2.5deg); }
            90%  { transform: rotate(1deg); }
            100% { transform: rotate(0deg); }
        }
    `;

    const toggleTransferSelection = () => {
        const transferSelectionState = !transferSelection;
        setTransferSelection(transferSelectionState);
        setTransferCalls(false);
        resetTransferSelection();
        setTransferSelectionValue('');
        setExternalDisplay('');
    };

    const handleGetTransferToUsers = async () => {
        const transferCallState = !transferCalls;
        if (transferCallState) {
            try {
                const authyToken = localStorage.getItem(authToken);
                const response = await api.get('/user/usersfortransfer', {
                    headers: { Authorization: `Bearer ${authyToken}` },
                });
                setTransferToUsers(response.data.data);
            } catch (error) {
                console.error('Error fetching Disposition Group:', error);
            }
        }
    };

    const handleButtonDelete = () => {
        setDialDisplay(dialdisplay.slice(0, -1));
    };

    const handleDialButtonClick = (num) => {
        setDialDisplay(dialdisplay + num);
    };

    useEffect(() => {
        const handleDailerTabChange = (event) => {
            setSelectedDailerTab(event.detail);
        };
        window.addEventListener('dialerTabChange', handleDailerTabChange);
        return () => window.removeEventListener('dialerTabChange', handleDailerTabChange);
    }, []);

    useEffect(() => {
        const handleCampaignModeChange = () => {
            setSelectedDailerTab(3);
            setFlashSwitch(true);
            const timer = setTimeout(() => setFlashSwitch(false), 300);
            return () => clearTimeout(timer);
        };
        window.addEventListener('campaignMode', handleCampaignModeChange);
        return () => window.removeEventListener('campaignMode', handleCampaignModeChange);
    }, []);

    const startTime = () => startTimer();
    const resetTime = () => { setTimeout(() => resetTimer(), 3000); };
    const resetTimeIncoming = () => resetTimer();

    // ── Safe duration helper ──────────────────────────────────────────────────
    const getSafeDuration = () => {
        const raw = getCurrentTimer();
        if (!raw || raw === '00:00:00') return '00:00:01';
        return raw;
    };

    const handleTransferChange = (event) => {
        if (unattendedInternalStatus) {
            setTransferExtension(event.target.value);
            forwardCall(event.target.value);
        } else {
            setTransferExtension(event.target.value);
            forwardAttendedExternalCall(event.target.value);
        }
    };

    // ── Media Elements Helper ─────────────────────────────────────────────────
    const setupMediaElements = () => {
        let remoteAudio = document.getElementById('remote-audio');
        let localAudio = document.getElementById('local-audio');
        if (!remoteAudio) {
            remoteAudio = document.createElement('audio');
            remoteAudio.id = 'remote-audio';
            remoteAudio.autoPlay = true;
            document.body.appendChild(remoteAudio);
        }
        if (!localAudio) {
            localAudio = document.createElement('audio');
            localAudio.id = 'local-audio';
            localAudio.autoPlay = true;
            localAudio.muted = true;
            document.body.appendChild(localAudio);
        }
        // Private audio for the conference third party. While the parent call is
        // held, the agent hears the third party through THIS element. After merge
        // it REMAINS the agent's only path to hear party2 — remote-audio still
        // carries only party1, and parentMix is an OUTBOUND sender track that is
        // never played locally. So this element stays unmuted for the duration of
        // the conference (see joinConferenceCall).
        let conferenceAudio = document.getElementById('conference-audio');
        if (!conferenceAudio) {
            conferenceAudio = document.createElement('audio');
            conferenceAudio.id = 'conference-audio';
            conferenceAudio.autoPlay = true;
            document.body.appendChild(conferenceAudio);
        }
        return { remoteAudio, localAudio, conferenceAudio };
    };

    // ── Internet Connectivity Handlers ────────────────────────────────────────
    useEffect(() => {
        const handleOnline = () => {
            console.log('Internet connection restored');
            setIsOnline(true);
            setTimeout(checkRegistrationStatus, 2000);
        };
        const handleOffline = () => {
            console.log('Internet connection lost');
            setIsOnline(false);
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
            activeCallSessionRef.current = null;
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        checkInternetConnectivity();
        connectivityCheckIntervalRef.current = setInterval(checkInternetConnectivity, 10000);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            if (connectivityCheckIntervalRef.current) clearInterval(connectivityCheckIntervalRef.current);
        };
    }, []);

    const checkInternetConnectivity = async () => {
        try {
            await fetch('https://www.google.com/favicon.ico', { mode: 'no-cors' });
            if (!isOnline) setIsOnline(true);
        } catch (error) {
            setIsOnline(false);
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
        }
    };

    useEffect(() => {
        if (userAgentRef.current && isOnline) {
            statusCheckIntervalRef.current = setInterval(() => {
                checkRegistrationStatus();
            }, 30000);
        }
        return () => {
            if (statusCheckIntervalRef.current) clearInterval(statusCheckIntervalRef.current);
        };
    }, [userAgentRef.current, isOnline]);

    const checkRegistrationStatus = () => {
        if (!isOnline) {
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
            return;
        }
        if (!userAgentRef.current) {
            setVoipSignalStatus('#FF160C');
            return;
        }
        const isConnected = userAgentRef.current.isConnected();
        if (!isConnected) {
            setVoipSignalStatus('#FF160C');
            setConnectionStatus('disconnected');
            try {
                userAgentRef.current.stop();
                handleDroppedCallUI();
                setupSIPClient();
                setTimeout(() => userAgentRef.current.start(), 1000);
            } catch (error) {
                console.error('Error restarting connection:', error);
            }
            return;
        }
        const isRegistered = registererRef.current
            ? registererRef.current.state === RegistererState.Registered
            : false;
        if (isRegistered) {
            setVoipSignalStatus('#39FF14');
            setRegistered(true);
            setConnectionStatus('connected');
        } else {
            setVoipSignalStatus('#FFFF00');
            setConnectionStatus('connecting');
            if (registrationTimeoutRef.current) clearTimeout(registrationTimeoutRef.current);
            registrationTimeoutRef.current = setTimeout(() => {
                if (!registered) setVoipSignalStatus('#FFA500');
            }, 5000);
            try {
                registererRef.current.register();
            } catch (error) {
                console.error('Error during registration:', error);
                setVoipSignalStatus('#FF160C');
                setConnectionStatus('failed');
            }
        }
    };

    const handleManualRegister = () => checkRegistrationStatus();

    useEffect(() => {
        setCallLogDuration(timer);
    }, [timer]);

    const handleIncomingCallUI = () => {
        setSelectedDailerTab(0);
        setMakingCall(false);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(true);
        setAcceptedCall(false);
        playIncomingTone();
        stopEndTone();
        stopOutgoingTone();
        resetTimeIncoming();
    };

    const handleAcceptingCallUI = () => {
        setMakingCall(false);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(false);
        setAcceptedCall(true);
        startTime();
        stopEndTone();
        stopIncomingTone();
        stopOutgoingTone();
        setDispositionHangupButton('');
        setRingtoneIcon(true);
    };

    const handleDroppedCallUI = () => {
        setMakingCall(false);
        setDisplayInput(true);
        setDialerButtons(true);
        setShowIncomingCall(false);
        setAcceptedCall(false);
        setShowConnecting('');
        handleContactName('');
        setHideCallButtonsAccept(true);
        cleanupMediaElements();
        cleanupMediaStreams();
        setIsMuted(false);
        setIsHeld(false);
        setDtmfButtons(false);
        setDTMFValue('');
        stopEndTone();
        stopIncomingTone();
        stopOutgoingTone();
        setTransferCalls(false);
        setExternalTransferCalls(false);
        setTransferSelection(false);
        setExternalDisplay('');
        setDispositionHangupButton('none');
        resetTime();
        endCall();
        setDialDisplay('');
        setExternalAttendedTransferCalls(false);
        setTransferExtension('');
        setIsRingtoneMuted(false);

        // ── MIC-RELEASE FIX ────────────────────────────────────────────────
        // Capture the parent peer-connection BEFORE we null the session refs.
        // After a conference, teardownConference() asynchronously restores the
        // pristine mic onto the parent sender — but nothing ever stops it, and
        // the normal detachMediaStreams path below is skipped once the refs are
        // null. So the getUserMedia device stays live and the mic indicator
        // stays lit. We grab the PC here, run teardown, then explicitly stop
        // every outgoing audio sender track on it (plus the stashed mic refs).
        const parentPcForCleanup =
            activeCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            incomingCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            outgoingCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            null;

        // Tear the conference down while the peer connections are STILL live —
        // teardownConference needs them to restore mic tracks and end the child
        // leg. Must run before the refs below are nulled. Idempotent, so it's a
        // no-op if there was no conference or it was already torn down.
        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }

        // Now stop EVERY outgoing audio track on the parent PC — including the
        // pristine mic restored by teardownConference — so getUserMedia releases
        // the device and the mic indicator turns off on ANY hangup (local or
        // remote) after a conference.
        if (parentPcForCleanup) {
            try {
                parentPcForCleanup.getSenders().forEach(sender => {
                    if (sender.track && sender.track.kind === 'audio') {
                        try { sender.track.stop(); } catch (_) {}
                    }
                });
            } catch (_) {}
        }
        // Belt-and-braces: stop the stashed mic refs directly in case the async
        // restore hasn't reattached them to a sender yet.
        [parentMicTrackRef, confMicTrackRef].forEach(ref => {
            if (ref.current) {
                try { ref.current.stop(); } catch (_) {}
                ref.current = null;
            }
        });
        // ───────────────────────────────────────────────────────────────────

        [incomingCallSessionRef, outgoingCallSessionRef, activeCallSessionRef].forEach(ref => {
            if (ref.current) ref.current = null;
        });
        const currentSession =
            incomingCallSessionRef.current ||
            outgoingCallSessionRef.current ||
            activeCallSessionRef.current;
        if (currentSession) detachMediaStreams(currentSession);
        clearIceRecoveryTimer();
        stopRecording();
    };

    const handleMakingCallUI = () => {
        setMakingCall(true);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(false);
        setAcceptedCall(false);
    };

    const cleanupMediaStreams = () => {
        const remoteAudio = document.getElementById('remote-audio');
        const localAudio = document.getElementById('local-audio');
        if (remoteAudio && remoteAudio.srcObject) {
            remoteAudio.srcObject.getTracks().forEach(track => track.stop());
            remoteAudio.srcObject = null;
        }
        if (localAudio && localAudio.srcObject) {
            localAudio.srcObject.getTracks().forEach(track => track.stop());
            localAudio.srcObject = null;
        }
        if (incomingCallSessionRef.current?.sessionDescriptionHandler?.peerConnection) {
            const pc = incomingCallSessionRef.current.sessionDescriptionHandler.peerConnection;
            pc.getSenders().forEach(sender => sender.track?.stop());
            pc.getReceivers().forEach(receiver => receiver.track?.stop());
            pc.close();
        }
    };

    const addToQueue = (invitation, reason) => {
        try {
            const fromHeader = invitation.request.from;
            const callerNumber = fromHeader.uri.user;
            const callId = invitation.request.getHeader('Call-ID');
            const queuePayload = {
                callId,
                callerNumber,
                callerName: '',
                queueName: sessionStorage.getItem('queue_name') || 'Default',
                joinTime: new Date().toISOString(),
                reason,
            };
            handleContactName(callerNumber).then?.(() => {
                if (contactName) queuePayload.callerName = contactName;
            }).catch(() => { });
            socketRef.current?.emit('QUEUE_CALLER_ADD', queuePayload);
        } catch (e) {
            console.error('[Queue] Failed to emit QUEUE_CALLER_ADD:', e);
        }
    };

    const handleIncomingCall = (invitation) => {
        if (!callEnabledRef.current) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'disabled');
            return;
        }
        if (activeCallSessionRef.current) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'busy');
            return;
        }
        if (takeBreakRef.current) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'break');
            return;
        }
        incomingCallSessionRef.current = invitation;
        activeCallSessionRef.current = invitation;
        const fromHeader = activeCallSessionRef.current.request.from;
        const callerNumber = fromHeader.uri.user;
        recording_call_id.current = activeCallSessionRef.current.request.getHeader('Call-ID');
        setIncomingNumber(callerNumber);
        setDialerNumber(callerNumber);
        handleContactName(callerNumber);
        setDispositionContact(callerNumber);
        handleIncomingCallUI();
        setupMediaElements();
        showCallNotification(callerNumber);
        if (autoAnswerRef.current) {
            acceptIncomingCall(activeCallSessionRef.current);
            return;
        }
        activeCallSessionRef.current.delegate = {
            onBye: () => { handleDroppedCallUI(); },
            onReject: () => { handleDroppedCallUI(); },
            onCancel: () => {
                handleAddCallLog('Missed', 'incoming', sessionStorage.getItem('extension'), activeCallSessionRef.current.request.from.uri.user);
                handleDroppedCallUI();
            },
        };
        setAcceptCallHandler(() => () => acceptIncomingCall(activeCallSessionRef.current));
        setRejectCallHandler(() => () => rejectIncomingCall(incomingCallSessionRef.current));
    };

    const acceptIncomingCall = async (invitation) => {
        if (!invitation) return;
        try {
            stopIncomingTone();
            setShowConnecting('Connecting...');
            setRingtoneIcon(false);
            setHideCallButtonsAccept(false);
            const session = await invitation.accept({
                sessionDescriptionHandlerOptions: {
                    constraints: { audio: true, video: false },
                },
            });
            handleAcceptingCallUI();
            setCallType('incoming');

            const callerNumber = activeCallSessionRef.current.request.from.uri.user;
            const extensionNumber = sessionStorage.getItem('extension');

            incomingCallLoggedRef.current = false;
            const logIncomingOnce = (disposition) => {
                if (incomingCallLoggedRef.current) return;
                incomingCallLoggedRef.current = true;
                handleAddCallLog(disposition, 'incoming', extensionNumber, callerNumber);
            };

            handleAddCallLog('Picked', 'incoming', extensionNumber, callerNumber);

            if (session && typeof session.stateChange !== 'undefined' && session.stateChange) {
                session.stateChange.addListener((state) => {
                    if (state === SessionState.Established) {
                        attachMediaStreams(invitation);
                    } else if (state === SessionState.Terminated || state === SessionState.Failed) {
                        handleDroppedCallUI();
                    }
                });
            } else {
                setTimeout(() => attachMediaStreams(invitation), 1000);
            }
            attachMediaStreams(invitation);
            invitation.stateChange.addListener((state) => {
                switch (state) {
                    case SessionState.Established:
                        attachMediaStreams(invitation);
                        handleAcceptingCallUI();
                        break;
                    case SessionState.Terminated:
                        if (invitation) {
                            invitation.stateChange.removeAllListeners();
                            incomingCallSessionRef.current = null;
                            logIncomingOnce(getSafeDuration());
                            handleDroppedCallUI();
                        } else {
                            handleDroppedCallUI();
                        }
                        break;
                }
            });
            invitation.delegate = {
                onCancel: () => {
                    logIncomingOnce('Canceled');
                    handleDroppedCallUI();
                    cleanupCall();
                },
                onBye: () => {
                    const currentTime = getSafeDuration();
                    logIncomingOnce(currentTime);
                    cleanupCall();
                    handleDroppedCallUI();
                    playEndTone();
                },
                onReject: () => {
                    logIncomingOnce('Rejected');
                    cleanupCall();
                    handleDroppedCallUI();
                },
            };
            const cleanupCall = () => {
                try {
                    [incomingCallSessionRef, activeCallSessionRef].forEach(ref => {
                        ref.current?.stateChange?.removeAllListeners();
                        ref.current = null;
                    });
                } catch (e) {
                    console.warn('Cleanup error:', e);
                }
            };
        } catch (error) {
            console.error('Error accepting call:', error);
            incomingCallSessionRef.current = null;
            activeCallSessionRef.current = null;
        }
    };

    const rejectIncomingCall = () => {
        const session = incomingCallSessionRef.current;
        if (!session) return;
        try {
            if (session.state !== SessionState.Terminated) session.reject();
        } catch (error) {
            console.error('Error rejecting call:', error);
        } finally {
            handleAddCallLog('Rejected', 'incoming', sessionStorage.getItem('extension'), session.request.from.uri.user);
            incomingCallSessionRef.current = null;
            activeCallSessionRef.current = null;
            handleDroppedCallUI();
        }
    };

    // ── Campaign: advance exactly ONCE per dialed contact ────────────────────
    const advanceCampaignOnce = (guard) => {
        if (!campaignModeRef.current || campaignDoneRef.current) return;
        const g = guard || callLoggedRef.current;
        if (!g || g.advanced) return;
        g.advanced = true;

        // ✅ FIX A: Clear any pending per-contact timeout so it can't double-fire
        if (campaignTimeoutRef.current) {
            clearTimeout(campaignTimeoutRef.current);
            campaignTimeoutRef.current = null;
        }

        // Derive the next index from the index THIS guard was stamped with in
        // makeCall — not from the mutable currentContactIndexRef. This is the
        // core fix for the "last number repeats N times" bug: several end-events
        // for the same contact all carry the same stamped index, so they all
        // resolve to the same nextIndex, and once one has advanced (g.advanced)
        // the rest are no-ops. Falling back to the ref keeps manual/edge cases
        // working if a guard somehow arrived unstamped.
        const baseIndex = (g.contactIndex != null) ? g.contactIndex : currentContactIndexRef.current;
        const nextIndex = baseIndex + 1;

        // If we've reached the end, latch completion HERE so nothing else can
        // re-enter, then run the clean teardown via dialNextContact's end branch.
        if (nextIndex >= campaignContactsRef.current.length) {
            campaignDoneRef.current = true;
            setTimeout(() => dialNextContact(campaignContactsRef.current, nextIndex), 2000);
            return;
        }

        currentContactIndexRef.current = nextIndex;
        setCurrentContactIndex(nextIndex);
        setTimeout(() => dialNextContact(campaignContactsRef.current, nextIndex), 2000);
    };

    const hangUpCall = () => {
        const snapshotCallType = callType;
        const snapshotDialerNumber = dialedNumberRef.current ?? dialerNumber;
        const snapshotExtension = sessionStorage.getItem('extension');
        const snapshotWasEstablished = callEstablishedRef.current;

        // Drop the third party (and restore mic tracks) before ending the parent,
        // so nobody is briefly wired to a dead mix. handleDroppedCallUI below also
        // calls this — it's idempotent, so the second call is a no-op.
        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }

        const endSession = (session) => {
            try {
                session?.state !== SessionState.Terminated && session?.bye();
            } catch (e) {
                console.warn('Error ending call:', e);
            }
        };
        try {
            endSession(outgoingCallSessionRef.current);
            endSession(incomingCallSessionRef.current);
            outgoingCallSessionRef.current = null;
            incomingCallSessionRef.current = null;
        } finally {
            const currentTime = getSafeDuration();
            if (snapshotCallType === 'outgoing') {
                const guard = callLoggedRef.current;
                if (guard && !guard.done) {
                    guard.done = true;
                    const disposition = snapshotWasEstablished ? currentTime : 'No Answer';
                    handleAddCallLog(disposition, snapshotCallType, snapshotDialerNumber, snapshotExtension);
                }
            } else {
                if (!incomingCallLoggedRef.current) {
                    incomingCallLoggedRef.current = true;
                    handleAddCallLog(currentTime, snapshotCallType, snapshotDialerNumber, snapshotExtension);
                }
            }
            handleDroppedCallUI();
            playEndTone();
            advanceCampaignOnce();
        }
    };

    const hangUpCallOutGoing = () => {
        const guard = callLoggedRef.current;
        if (guard && !guard.done) {
            guard.done = true;
            handleAddCallLog(
                'No Answer',
                'outgoing',
                dialedNumberRef.current ?? dialerNumber,
                sessionStorage.getItem('extension')
            );
        }
        if (outgoingCallSessionRef.current) {
            try { outgoingCallSessionRef.current.cancel(); } catch (e) { console.warn('Cancel error:', e); }
            outgoingCallSessionRef.current = null;
        } else if (activeCallSessionRef.current) {
            try { activeCallSessionRef.current.cancel(); } catch (e) { console.warn('Cancel error:', e); }
            activeCallSessionRef.current = null;
        }
        handleDroppedCallUI();

        // ✅ FIX C: ensure the campaign list keeps moving after a no-answer/manual hangup
        advanceCampaignOnce(guard);
    };

    const dispositionHangUpCall = () => {
        // Drop the third party (and restore mic tracks) before ending the parent.
        // Idempotent — handleDroppedCallUI calls it again harmlessly.
        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }
        const endSession = (session) => {
            try {
                if (session) {
                    session.state !== SessionState.Terminated ? session.bye() : session.cancel();
                }
            } catch (e) {
                console.warn('Error ending call:', e);
            }
        };
        try {
            if (outgoingCallSessionRef.current) { endSession(outgoingCallSessionRef.current); outgoingCallSessionRef.current = null; }
            if (incomingCallSessionRef.current) { endSession(incomingCallSessionRef.current); incomingCallSessionRef.current = null; }
            if (activeCallSessionRef.current) { endSession(activeCallSessionRef.current); activeCallSessionRef.current = null; }
        } finally {
            const currentTime = getSafeDuration();
            const destination = callTypeCallLog === 'incoming' ? sessionStorage.getItem('extension') : dialerNumber;
            const source = callTypeCallLog === 'incoming' ? dialerNumber : sessionStorage.getItem('extension');
            handleAddCallLog(currentTime, callTypeCallLog, destination, source);
            handleDroppedCallUI();
            playEndTone();
        }
    };

    const cleanupMediaElements = () => {
        if (remoteAudioRef.current) {
            remoteAudioRef.current.srcObject = null;
            remoteAudioRef.current.remove();
            remoteAudioRef.current = null;
        }
        if (localAudioRef.current) {
            localAudioRef.current.srcObject = null;
            localAudioRef.current.remove();
            localAudioRef.current = null;
        }
    };

    // Unmount cleanup
    useEffect(() => {
        return () => {
            if (campaignTimeoutRef.current) clearTimeout(campaignTimeoutRef.current);
            clearIceRecoveryTimer();
            audioCtxRef.current?.close();
            closeMixContexts();
            handleDroppedCallUI();
        };
    }, []);

    const setupSIPClient = async () => {
        const WsServer = sessionStorage.getItem('WsServer');
        const Extension = sessionStorage.getItem('Extension');
        const ExtPass = sessionStorage.getItem('ExtPass');
        const URI = sessionStorage.getItem('Uri');
        if (WsServer && Extension && ExtPass && URI) {
            const uri = UserAgent.makeURI(URI);
            if (!uri) { console.error('Failed to create target URI.'); return; }
            const userAgent = new UserAgent({
                uri,
                transportOptions: { wsServers: [WsServer], connectionTimeout: 10 },
                authorizationUsername: Extension,
                authorizationPassword: ExtPass,
                reconnectionAttempts: 5,
                reconnectionDelay: 5,
                sessionDescriptionHandlerFactoryOptions: {
                    iceCheckingTimeout: 10000,
                    rtcConfiguration: { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] },
                },
            });
            userAgentRef.current = userAgent;
            const registerer = new Registerer(userAgent);
            registererRef.current = registerer;
            userAgent.delegate = {
                onConnect: () => {
                    setConnectionStatus('connected');
                    setVoipSignalStatus('#FFFF00');
                    registerer.register();
                },
                onDisconnect: () => {
                    setRegistered(false);
                    setVoipSignalStatus('#888888');
                    setConnectionStatus('disconnected');
                },
                onInvite: (invitation) => handleIncomingCall(invitation),
            };
            registerer.stateChange.addListener((newState) => {
                switch (newState) {
                    case RegistererState.Registered:
                        setRegistered(true);
                        setVoipSignalStatus('#39FF14');
                        setConnectionStatus('connected');
                        break;
                    case RegistererState.Unregistered:
                        setRegistered(false);
                        setVoipSignalStatus('#FF160C');
                        setConnectionStatus('disconnected');
                        break;
                    case RegistererState.Terminated:
                        setRegistered(false);
                        setVoipSignalStatus('#888888');
                        setConnectionStatus('disconnected');
                        break;
                }
            });
            try {
                await userAgent.start();
            } catch (error) {
                console.error('Failed to start UserAgent:', error);
                setVoipSignalStatus('#FF160C');
                setConnectionStatus('disconnected');
            }
        } else {
            console.warn('SIP client setup skipped - missing configuration data');
        }
    };

    // True if the string is dialable (digits / + / spaces only — no letters).
    // Name search results must be tapped first so the field holds a real number.
    const isDialableNumber = (value) => {
        if (!value || typeof value !== 'string') return false;
        const trimmed = value.trim();
        if (!trimmed) return false;
        // Reject any alphabetic characters (contact name search)
        if (/[a-zA-Z]/.test(trimmed)) return false;
        // Must contain at least one digit
        if (!/\d/.test(trimmed)) return false;
        return true;
    };

    const makeCall = (phoneNumberParam) => {
        if (!userAgentRef.current || !registered) {
            console.error('Cannot make call - not registered or userAgent not initialized');
            return;
        }
        // Precedence FIX: an explicitly-passed number (campaign auto-dialer or any
        // programmatic dial) must win over the dialdisplay text-field state.
        // dialdisplay is React state and lags a render behind the setDialDisplay()
        // that dialNextContact fires right before calling makeCall — so reading it
        // first made every campaign contact after the first re-dial the STALE last
        // number (the value left in dialdisplay when the previous cycle ended).
        // The manual dial button calls makeCall() with no argument, so it still
        // falls back to dialdisplay as before.
        const numberToUse =
            (typeof phoneNumberParam === 'string' && phoneNumberParam.trim() !== '')
                ? phoneNumberParam
                : dialdisplay;

        // Block outbound if the field still holds a name / letters.
        // Campaign / programmatic dials pass a clean phoneNumberParam and pass through.
        if (!isDialableNumber(numberToUse)) {
            console.warn('[Dial] Call blocked — input is not a phone number:', numberToUse);
            return;
        }

        if (numberToUse) {
            let dialednumber;
            if (numberToUse.length > 4) {
                const DialNumber = numberToUse.replace(/\s/g, '');
                const cleanedNumber = DialNumber.replace(/\D/g, '');
                if (/^0\d{9}$/.test(cleanedNumber)) {
                    dialednumber = `254${cleanedNumber.substring(1)}`;
                } else if (/^254\d{9}$/.test(cleanedNumber)) {
                    dialednumber = cleanedNumber;
                } else if (/^256\d{9}$/.test(cleanedNumber)) {
                    dialednumber = cleanedNumber;
                } else if (/^\+\d+$/.test(DialNumber)) {
                    dialednumber = DialNumber;
                } else {
                    dialednumber = DialNumber;
                }
            } else {
                dialednumber = numberToUse.replace(/\s/g, '');
            }
            handleMakingCallUI();
            setDialerNumber(dialednumber);
            handleContactName(dialednumber);
            setDispositionContact(dialednumber);
            dialedNumberRef.current = dialednumber;
            // Stamp the guard with the contact index it belongs to (campaign only).
            // advanceCampaignOnce derives the NEXT index from this stamp instead of
            // the mutable currentContactIndexRef, so racing end-events for the same
            // contact all compute the same next index and can't re-dial the last one.
            const thisCallGuard = {
                done: false,
                advanced: false,
                contactIndex: campaignModeRef.current ? currentContactIndexRef.current : null,
            };
            callLoggedRef.current = thisCallGuard;
            callEstablishedRef.current = false;
            const Server_Url = sessionStorage.getItem('Server_Url');
            const targetURI = `sip:${dialednumber}@${Server_Url}`;
            const target = UserAgent.makeURI(targetURI);
            if (!target) { console.error('Invalid destination URI'); return; }
            setupMediaElements();
            const inviter = new Inviter(userAgentRef.current, target);
            outgoingCallSessionRef.current = inviter;
            const logCallOnce = (disposition) => {
                if (thisCallGuard.done) return;
                thisCallGuard.done = true;
                handleAddCallLog(disposition, 'outgoing', dialednumber, sessionStorage.getItem('extension'));
            };
            inviter.invite({
                sessionDescriptionHandlerOptions: { constraints: { audio: true, video: false } },
            }).then(() => {
                activeCallSessionRef.current = inviter;
                outgoingCallSessionRef.current = inviter;
                recording_call_id.current = activeCallSessionRef.current.request.getHeader('Call-ID');
                playOutgoingTone();
                inviter.delegate = {
                    onBye: () => {
                        const currentTime = getSafeDuration();
                        logCallOnce(currentTime);
                        handleDroppedCallUI();
                        playEndTone();
                        advanceCampaignOnce(thisCallGuard);
                    },
                };
                if (inviter && typeof inviter.stateChange !== 'undefined' && inviter.stateChange) {
                    inviter.stateChange.addListener((state) => {
                        if (state === SessionState.Established) {
                            callEstablishedRef.current = true;
                            attachMediaStreams(inviter);
                            handleAcceptingCallUI();
                            setDialerNumber(dialednumber);
                            setCallType('outgoing');
                            startCallOutGoing();
                        }
                        if (state === SessionState.Terminated) {
                            inviter.stateChange.removeAllListeners();
                            const disposition = callEstablishedRef.current
                                ? getSafeDuration()
                                : 'No Answer';
                            logCallOnce(disposition);
                            handleDroppedCallUI();
                            setDialDisplay(dialednumber);
                            playEndTone();
                            detachMediaStreams(inviter);
                            advanceCampaignOnce(thisCallGuard);
                        } else if (state === SessionState.Failed) {
                            logCallOnce('Failed');
                            handleDroppedCallUI();
                            setDialDisplay(dialednumber);
                            playEndTone();
                            advanceCampaignOnce(thisCallGuard);
                        }
                    });
                } else {
                    setTimeout(() => attachMediaStreams(inviter), 1000);
                }
                outgoingCallSessionRef.current.onReject = (response) => {
                    const statusCode = response.message.statusCode;
                    let call_dispose = 'Failed';
                    if (statusCode === 486) call_dispose = 'Busy';
                    else if (statusCode === 480) call_dispose = 'No Answer';
                    else if (statusCode === 404) call_dispose = 'Invalid Number';
                    else if (statusCode === 403) call_dispose = 'Forbidden';
                    else if (statusCode === 408) call_dispose = 'Timeout';
                    logCallOnce(call_dispose);
                    detachMediaStreams(inviter);
                    handleDroppedCallUI();
                    advanceCampaignOnce(thisCallGuard);
                };
            }).catch(error => {
                logCallOnce('Failed');
                handleDroppedCallUI();
                activeCallSessionRef.current = null;
                advanceCampaignOnce(thisCallGuard);
            });
        }
    };

    // ── ICE recovery helpers ─────────────────────────────────────────────────
    const clearIceRecoveryTimer = () => {
        if (iceRecoveryTimerRef.current) {
            clearTimeout(iceRecoveryTimerRef.current);
            iceRecoveryTimerRef.current = null;
        }
    };

    const attachMediaStreams = (session) => {
        if (!session?.sessionDescriptionHandler?.peerConnection) {
            console.error('Session/peer connection not available');
            return;
        }
        const peerConnection = session.sessionDescriptionHandler.peerConnection;
        const { remoteAudio, localAudio } = setupMediaElements();
        try {
            const receivers = peerConnection.getReceivers();
            const audioReceivers = receivers.filter(r => r.track && r.track.kind === 'audio');
            if (audioReceivers.length > 0) {
                const stream = new MediaStream([audioReceivers[0].track]);
                remoteAudio.srcObject = stream;
                remoteAudio.play().catch(e => {
                    document.addEventListener('click', function playOnClick() {
                        remoteAudio.play();
                        document.removeEventListener('click', playOnClick);
                    });
                });
            }
            const senders = peerConnection.getSenders();
            const audioSenders = senders.filter(s => s.track && s.track.kind === 'audio');
            if (audioSenders.length > 0) {
                const stream = new MediaStream([audioSenders[0].track]);
                localAudio.srcObject = stream;
                localAudio.play().catch(e => console.error('Error playing local audio:', e));
            }
            const remoteTrack = audioReceivers[0]?.track;
            const localTrack = audioSenders[0]?.track;

            // ✅ FIX: Retry attaching media if tracks aren't ready immediately
            if (remoteTrack && localTrack) {
                recordStereo(remoteTrack, localTrack);
            } else {
                console.warn('[Audio] Tracks not ready, retrying in 500ms...', {
                    hasRemote: !!remoteTrack, hasLocal: !!localTrack
                });
                setTimeout(() => attachMediaStreams(session), 500);
            }

            // ── ICE connection state monitor ──────────────────────────────────
            peerConnection.oniceconnectionstatechange = () => {
                const state = peerConnection.iceConnectionState;
                console.log('[ICE] Connection state:', state);

                if (state === 'disconnected') {
                    clearIceRecoveryTimer();
                    iceRecoveryTimerRef.current = setTimeout(() => {
                        if (peerConnection.iceConnectionState !== 'connected' &&
                            peerConnection.iceConnectionState !== 'completed') {
                            console.warn('[ICE] Recovery timeout — forcing call cleanup');
                            handleDroppedCallUI();
                            playEndTone();
                        }
                    }, 6000);
                } else if (state === 'failed') {
                    console.warn('[ICE] Connection failed — forcing call cleanup');
                    clearIceRecoveryTimer();
                    handleDroppedCallUI();
                    playEndTone();
                } else if (state === 'connected' || state === 'completed') {
                    clearIceRecoveryTimer();
                }
            };
        } catch (error) {
            console.error('Error attaching media streams:', error);
        }
    };

    const detachMediaStreams = (session) => {
        if (!session?.sessionDescriptionHandler?.peerConnection) return;
        const peerConnection = session.sessionDescriptionHandler.peerConnection;
        const senders = peerConnection.getSenders();
        if (senders && senders.length > 0) {
            senders.filter(s => s.track && s.track.kind === 'audio').forEach(s => s.track.stop());
        }
        const { remoteAudio, localAudio } = setupMediaElements();
        if (remoteAudio) remoteAudio.srcObject = null;
        if (localAudio) localAudio.srcObject = null;
    };

    // ══════════════════════════════════════════════════════════════════════════
    // CONFERENCE CALL (3-party, browser-mixed) — mirrors Browser-Phone's approach
    //
    // No FreeSWITCH conference bridge. Two independent SIP legs exist:
    //   • parent  = activeCallSessionRef (the original call)
    //   • child   = conferenceSessionRef (the agent <-> third party)
    // On merge, for EACH peer connection we build a MediaStreamDestination that
    // sums the agent's mic + the OTHER leg's remote voice, then replaceTrack()
    // that mixed track into the sender. No SDP renegotiation needed.
    //
    // AGENT MONITORING: after merge, remote-audio still plays only party1 and the
    // outbound mixes are never played locally, so the agent hears party2 solely
    // through the private conference-audio element — which is why it must stay
    // UNMUTED for the whole conference. (Earlier code muted it on merge, which
    // silenced party2 for the agent.)
    // ══════════════════════════════════════════════════════════════════════════

    // Sum a set of MediaStreamTracks into one mixed audio track via a fresh
    // AudioContext. The synthesized track is tagged IsMixedTrack so mute/hold
    // logic can skip it (disabling it would kill the whole mix). Returns null on
    // failure so callers can bail cleanly.
    const MixAudioStreams = (tracks) => {
        try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            if (ctx.state === 'suspended') ctx.resume().catch(() => {});
            mixCtxRefs.current.push(ctx);
            const dest = ctx.createMediaStreamDestination();
            tracks
                .filter(t => t && t.readyState === 'live')
                .forEach(t => {
                    const src = ctx.createMediaStreamSource(new MediaStream([t]));
                    src.connect(dest);
                });
            const mixedTrack = dest.stream.getAudioTracks()[0];
            if (mixedTrack) mixedTrack.IsMixedTrack = true;
            return mixedTrack;
        } catch (e) {
            console.error('[Conf] MixAudioStreams failed:', e);
            return null;
        }
    };

    // Close every mixer AudioContext created during a conference.
    const closeMixContexts = () => {
        mixCtxRefs.current.forEach(ctx => {
            try { if (ctx.state !== 'closed') ctx.close(); } catch (_) {}
        });
        mixCtxRefs.current = [];
    };

    // Pull the first live remote (received) audio track off a session's PC.
    const getRemoteTrack = (session) => {
        const pc = session?.sessionDescriptionHandler?.peerConnection;
        if (!pc) return null;
        const recv = pc.getReceivers().find(r => r.track && r.track.kind === 'audio');
        return recv?.track || null;
    };

    // Restore a peer connection's outgoing audio to its ORIGINAL (un-mixed) mic
    // track. Honours the CURRENT mute state via the ref (not stale closure).
    //
    // MIC-RELEASE FIX: clear savedTrackRef AFTER kicking off the restore (not
    // before) so a racing hangup can't lose the reference before we've stopped
    // it. Also stop the outgoing mixed (IsMixedTrack) track once it's replaced,
    // so its AudioContext source detaches and doesn't keep the graph alive.
    const restoreOriginalTrack = (pc, savedTrackRef) => {
        if (!pc || !savedTrackRef.current) return;
        const original = savedTrackRef.current;
        pc.getSenders().forEach((sender) => {
            if (sender.track && sender.track.kind === 'audio') {
                const outgoing = sender.track; // the mixed track we're replacing
                sender.replaceTrack(original)
                    .then(() => {
                        if (outgoing && outgoing.IsMixedTrack) {
                            try { outgoing.stop(); } catch (_) {}
                        }
                        if (sender.track) sender.track.enabled = !isMutedRef.current;
                    })
                    .catch(e => console.error('[Conf] restoreOriginalTrack failed:', e));
            }
        });
        savedTrackRef.current = null; // clear AFTER kicking off restore
    };

    // Splice party2's remote audio OUT of the save-recording graph (called on
    // conference teardown). Leaves party1 + agent recording intact.
    const detachConfFromRecording = () => {
        if (confRecordSourceRef.current) {
            try { confRecordSourceRef.current.disconnect(); } catch (_) {}
            confRecordSourceRef.current = null;
        }
    };

    // Full conference teardown. Idempotent via confTeardownGuardRef so repeated
    // end-events (child BYE + parent hangup, etc.) don't double-run. Restores mic
    // tracks, stops the child leg, closes mixers, resets UI. Does NOT touch the
    // parent session refs — the caller (or handleDroppedCallUI) owns those.
    const teardownConference = () => {
        if (confTeardownGuardRef.current) return;
        confTeardownGuardRef.current = true;

        try {
            const parentPc = activeCallSessionRef.current?.sessionDescriptionHandler?.peerConnection;
            const childSession = conferenceSessionRef.current;
            const childPc = childSession?.sessionDescriptionHandler?.peerConnection;

            // Restore raw mic on the parent leg (only meaningful if we swapped it).
            if (parentPc) restoreOriginalTrack(parentPc, parentMicTrackRef);

            // Remove party2 from the save recording graph.
            detachConfFromRecording();

            // End the child leg. Stop its mic first so the device is released.
            if (childPc) {
                childPc.getSenders().forEach(s => {
                    // stop the child's ORIGINAL mic; the mixed track is ephemeral
                    if (s.track && !s.track.IsMixedTrack) { try { s.track.stop(); } catch (_) {} }
                });
                if (confMicTrackRef.current) { try { confMicTrackRef.current.stop(); } catch (_) {} }
                confMicTrackRef.current = null;
            }
            try {
                if (childSession && childSession.state !== SessionState.Terminated) {
                    // Inviter uses cancel() before Established, bye() after.
                    childSession.state === SessionState.Established
                        ? childSession.bye()
                        : childSession.cancel();
                }
            } catch (e) { console.warn('[Conf] child end error:', e); }
            conferenceSessionRef.current = null;

            closeMixContexts();

            // Re-point the parent's remote audio at its own remote track in case
            // the mix left the element wired to a mixer destination.
            const parentRemote = getRemoteTrack(activeCallSessionRef.current);
            const { remoteAudio, conferenceAudio } = setupMediaElements();
            if (remoteAudio && parentRemote) {
                remoteAudio.srcObject = new MediaStream([parentRemote]);
                remoteAudio.play().catch(() => {});
            }
            if (conferenceAudio) {
                conferenceAudio.srcObject = null;
                conferenceAudio.muted = false;
            }

            // If the parent was auto-held to set up the conference, release it.
            if (isHeldRef.current && activeCallSessionRef.current) {
                try { toggleHold(); } catch (_) {}
            }
        } catch (e) {
            console.error('[Conf] teardownConference error:', e);
        } finally {
            setConferencePanel(false);
            setConferenceDisplay('');
            setConferenceStatus('');
            setIsConfDialing(false);
            setIsConfReady(false);
            setIsConfJoined(false);
        }
    };

    // Open the conference dial panel. Puts the parent on hold so the agent can
    // speak privately to the third party while dialing. Mutually exclusive with
    // the transfer panel.
    const startConferenceCall = () => {
        if (!activeCallSessionRef.current) return;
        // Close transfer UI so the two panels never overlap.
        setTransferSelection(false);
        setTransferCalls(false);
        setExternalTransferCalls(false);
        setExternalAttendedTransferCalls(false);
        resetTransferSelection();

        if (conferencePanel || isConfJoined) {
            // Toggling off before a merge cancels; after a merge tears down.
            isConfJoined ? terminateConferenceCall() : cancelConference();
            return;
        }
        confTeardownGuardRef.current = false;
        setConferencePanel(true);
        setConferenceStatus('Enter a number to add to the call');
        if (!isHeldRef.current) { try { toggleHold(); } catch (_) {} }
    };

    // Close the panel WITHOUT having merged. Ends any half-dialed child leg and
    // takes the parent off hold.
    const cancelConference = () => {
        confTeardownGuardRef.current = false; // allow teardown to run
        teardownConference();
    };

    // Dial the third party as a SECOND independent SIP leg.
    const conferenceDial = (destinationRaw) => {
        if (!activeCallSessionRef.current || !userAgentRef.current) return;
        if (!destinationRaw) return;

        let dialednumber;
        const raw = String(destinationRaw);
        if (raw.length > 4) {
            const cleaned = raw.replace(/\D/g, '');
            if (/^0\d{9}$/.test(cleaned)) dialednumber = `254${cleaned.substring(1)}`;
            else if (/^254\d{9}$/.test(cleaned)) dialednumber = cleaned;
            else if (/^256\d{9}$/.test(cleaned)) dialednumber = cleaned;
            else if (/^\+\d+$/.test(raw.replace(/\s/g, ''))) dialednumber = raw.replace(/\s/g, '');
            else dialednumber = raw.replace(/\s/g, '');
        } else {
            dialednumber = raw.replace(/\s/g, '');
        }

        const Server_Url = sessionStorage.getItem('Server_Url');
        const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
        if (!target) { console.error('[Conf] Invalid destination URI'); return; }

        const inviter = new Inviter(userAgentRef.current, target);
        conferenceSessionRef.current = inviter;
        setIsConfDialing(true);
        setIsConfReady(false);
        setConferenceStatus(`Calling ${dialednumber}...`);

        inviter.invite({
            sessionDescriptionHandlerOptions: { constraints: { audio: true, video: false } },
        }).then(() => {
            inviter.stateChange.addListener((state) => {
                if (state === SessionState.Established) {
                    // Route the third party privately to the conference-audio
                    // element so the agent can talk to them while the parent is held.
                    const { conferenceAudio } = setupMediaElements();
                    const childRemote = getRemoteTrack(inviter);
                    if (conferenceAudio && childRemote) {
                        conferenceAudio.muted = false;
                        conferenceAudio.srcObject = new MediaStream([childRemote]);
                        conferenceAudio.play().catch(() => {});
                    }
                    setIsConfDialing(false);
                    setIsConfReady(true);
                    setConferenceStatus(`Connected to ${dialednumber} — press Merge to join all`);
                }
                if (state === SessionState.Terminated) {
                    inviter.stateChange.removeAllListeners();
                    // If the child drops (before OR after merge), collapse back to
                    // the original two-party call rather than killing everything.
                    if (isConfJoined) {
                        confTeardownGuardRef.current = false;
                        teardownConference();
                    } else {
                        conferenceSessionRef.current = null;
                        setIsConfDialing(false);
                        setIsConfReady(false);
                        setConferenceStatus('Third party unavailable');
                        const { conferenceAudio } = setupMediaElements();
                        if (conferenceAudio) conferenceAudio.srcObject = null;
                    }
                }
            });
        }).catch((e) => {
            console.error('[Conf] conferenceDial invite failed:', e);
            conferenceSessionRef.current = null;
            setIsConfDialing(false);
            setIsConfReady(false);
            setConferenceStatus('Failed to reach third party');
        });
    };

    // Cancel a ringing/answered child leg but keep the panel open so the agent
    // can dial a different number.
    const cancelConferenceDial = () => {
        const child = conferenceSessionRef.current;
        if (child) {
            try {
                child.state === SessionState.Established ? child.bye() : child.cancel();
            } catch (e) { console.warn('[Conf] cancelConferenceDial:', e); }
        }
        conferenceSessionRef.current = null;
        const { conferenceAudio } = setupMediaElements();
        if (conferenceAudio) conferenceAudio.srcObject = null;
        setIsConfDialing(false);
        setIsConfReady(false);
        setConferenceStatus('Enter a number to add to the call');
    };

    // THE MERGE. Build a mixed outgoing track for each leg and swap it in.
    //   parent sender gets:  agentMic + childRemote
    //   child  sender gets:  agentMic + parentRemote
    // Each party then hears the agent plus the other party. The AGENT continues
    // to hear party2 via the private conference-audio element (kept unmuted) and
    // party1 via remote-audio.
    const joinConferenceCall = () => {
        const parentSession = activeCallSessionRef.current;
        const childSession = conferenceSessionRef.current;
        const parentPc = parentSession?.sessionDescriptionHandler?.peerConnection;
        const childPc = childSession?.sessionDescriptionHandler?.peerConnection;
        if (!parentPc || !childPc) { console.error('[Conf] merge: missing peer connection'); return; }

        const parentSender = parentPc.getSenders().find(s => s.track && s.track.kind === 'audio');
        const childSender  = childPc.getSenders().find(s => s.track && s.track.kind === 'audio');
        const parentRemote = getRemoteTrack(parentSession);
        const childRemote  = getRemoteTrack(childSession);

        if (!parentSender?.track || !childSender?.track || !parentRemote || !childRemote) {
            console.error('[Conf] merge: tracks not ready', {
                ps: !!parentSender?.track, cs: !!childSender?.track,
                pr: !!parentRemote, cr: !!childRemote,
            });
            setConferenceStatus('Cannot merge yet — audio not ready');
            return;
        }

        // Save the PRISTINE mic tracks BEFORE swapping so we can restore later and
        // so recordStereo/relay never capture a doubled mix.
        parentMicTrackRef.current = parentSender.track;
        confMicTrackRef.current   = childSender.track;

        const parentMix = MixAudioStreams([parentSender.track, childRemote]);
        const childMix  = MixAudioStreams([childSender.track, parentRemote]);
        if (!parentMix || !childMix) {
            setConferenceStatus('Merge failed — audio mixer error');
            parentMicTrackRef.current = null;
            confMicTrackRef.current = null;
            closeMixContexts();
            return;
        }

        // Respect current mute state on the synthesized tracks.
        parentMix.enabled = !isMutedRef.current;
        childMix.enabled  = !isMutedRef.current;

        Promise.all([
            parentSender.replaceTrack(parentMix),
            childSender.replaceTrack(childMix),
        ]).then(() => {
            // ✅ FIX: keep conference-audio UNMUTED. After merge, remote-audio
            // plays party1 and parentMix is outbound-only (never played here),
            // so this element is the ONLY way the agent hears party2. Re-point
            // it at party2's live remote track and ensure it's audible.
            const { conferenceAudio } = setupMediaElements();
            if (conferenceAudio) {
                conferenceAudio.muted = false;
                if (childRemote) {
                    conferenceAudio.srcObject = new MediaStream([childRemote]);
                    conferenceAudio.play().catch(() => {});
                }
            }

            // ✅ FIX: splice party2 into the SAVE recording so the recorded file
            // captures all three parties. recordStereo panned party1 remote hard
            // right; add party2 to that same right-channel sink.
            spliceConfIntoRecording(childRemote);

            // Take the parent OFF hold so both parties are live.
            if (isHeldRef.current) { try { toggleHold(); } catch (_) {} }

            setIsConfJoined(true);
            setIsConfReady(false);
            setConferencePanel(false);
            setConferenceStatus('');
            console.log('[Conf] 3-way merge complete');
        }).catch((e) => {
            console.error('[Conf] replaceTrack during merge failed:', e);
            // Roll back cleanly.
            parentMicTrackRef.current = null;
            confMicTrackRef.current = null;
            closeMixContexts();
            setConferenceStatus('Merge failed');
        });
    };

    // Add party2's remote audio into the existing SAVE recording graph so the
    // stored recording contains all three parties. Uses the recording context
    // and the remote (right) panner created in recordStereo. No-op if the
    // recording graph isn't set up (e.g. tracks weren't ready).
    const spliceConfIntoRecording = (childRemoteTrack) => {
        try {
            const ctx = recordCtxRef.current;
            const remotePanner = recordRemotePannerRef.current;
            if (!ctx || !remotePanner || !childRemoteTrack) {
                console.warn('[Record] Conference splice skipped — graph not ready');
                return;
            }
            if (ctx.state === 'suspended') ctx.resume().catch(() => {});
            // Party2 shares the far-party (right) channel with party1.
            const confSource = ctx.createMediaStreamSource(new MediaStream([childRemoteTrack]));
            confSource.connect(remotePanner);
            confRecordSourceRef.current = confSource;
            console.log('[Record] Party2 spliced into save recording');
        } catch (e) {
            console.error('[Record] spliceConfIntoRecording failed:', e);
        }
    };

    // End the conference by dropping the third party but KEEPING the parent call.
    const terminateConferenceCall = () => {
        confTeardownGuardRef.current = false;
        teardownConference();
    };

    // ── recordStereo ──────────────────────────────────────────────────────────
    const recordStereo = (localTrack, remoteTrack) => {
        // Prevent multiple recorder instances
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
            console.log('[Audio] Save recorder already running');
            return;
        }

        if (audioCtxRef.current) {
            try { audioCtxRef.current.close(); } catch (e) { }
        }

        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        audioCtxRef.current = audioCtx;
        // Expose the recording context/panner so a later conference merge can
        // splice party2 into this same graph.
        recordCtxRef.current = audioCtx;

        // ✅ FIX: Ensure context is running so MediaStreamDestination doesn't produce silence
        if (audioCtx.state === 'suspended') {
            audioCtx.resume().catch(e => console.warn('[Audio] Failed to resume AudioContext:', e));
        }

        const destination = audioCtx.createMediaStreamDestination();
        const localSource  = audioCtx.createMediaStreamSource(new MediaStream([localTrack]));
        const remoteSource = audioCtx.createMediaStreamSource(new MediaStream([remoteTrack]));

        const localPanner  = audioCtx.createStereoPanner();
        localPanner.pan.value = -1;
        const remotePanner = audioCtx.createStereoPanner();
        remotePanner.pan.value = 1;
        // Keep the far-party (right) panner so party2 can join it on merge.
        recordRemotePannerRef.current = remotePanner;

        localSource.connect(localPanner).connect(destination);
        remoteSource.connect(remotePanner).connect(destination);

        // ── Save recorder (compliance / storage) ─────────────────────────
        const callIdForRecording = recording_call_id.current;
        const recorder = new MediaRecorder(destination.stream);
        mediaRecorderRef.current = recorder;
        recordedChunksRef.current = [];
        recorder.ondataavailable = (event) => {
            if (event.data.size > 0) recordedChunksRef.current.push(event.data);
        };
        recorder.onstop = () => {
            const blob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
            recordedChunksRef.current = [];
            uploadRecording(blob, callIdForRecording);
        };
        recorder.start();
        console.log('[Recording] Save recorder started');

        // [AUDIO] Live relay — keep the mixed stream so the relay recorder can
        // be restarted whenever a supervisor joins (REQUEST_CHUNK_RESEND).
        const callId = recording_call_id.current;
        liveStreamDestRef.current = destination.stream;
        if (callId && audioSocketRef.current?.connected) {
            console.log('[Audio] Setting up live relay for call:', callId);
            audioSocketRef.current.emit('REGISTER_CALL', { callId });
            startLiveRelay(callId);
        } else {
            console.warn('[Audio] Cannot start live relay - socket connected:', audioSocketRef.current?.connected, 'callId:', callId);
        }
    };

    // ── stopRecording ─────────────────────────────────────────────────────────
    const stopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop();
            console.log('[Recording] Save recorder stopped');
        }
        if (streamRecorderRef.current && streamRecorderRef.current.state !== 'inactive') {
            streamRecorderRef.current.stop();
            streamRecorderRef.current = null;
            console.log('[Audio] Live relay recorder stopped');
        }
        // Clear the conference recording splice + graph refs.
        detachConfFromRecording();
        recordRemotePannerRef.current = null;
        recordCtxRef.current = null;
        liveStreamDestRef.current = null;
        liveRelaySessionRef.current = null; // Invalidate session
        const callId = recording_call_id.current;
        if (callId && audioSocketRef.current?.connected) {
            audioSocketRef.current.emit('UNREGISTER_CALL', { callId });
        }
    };

    const uploadRecording = async (blob, callIdSnapshot = null) => {
        if (!blob || blob.size === 0) { console.warn('No recording found or file is empty.'); return; }
        const recording_id = callIdSnapshot ?? recording_call_id.current ?? '';
        if (!recording_id) { console.warn('[Recording] No call ID available — upload skipped'); return; }
        const formData = new FormData();
        formData.append('recording', blob, 'call_recording.webm');
        formData.append('recording_id', recording_id);
        try {
            const authyToken = localStorage.getItem(authToken);
            await api.post('/call/saverecording/', formData, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'multipart/form-data' },
                withCredentials: true,
            });
            console.log('Recording uploaded');
        } catch (err) {
            console.error('Upload failed', err);
        }
    };

    const showCallNotification = (callerNumber) => {
        const displayName = contactName ? contactName : callerNumber;
        if (Notification.permission === 'granted') {
            new Notification(`Incoming Call (${displayName})`);
        } else if (Notification.permission !== 'denied') {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') new Notification(`Incoming Call (${displayName})`);
            });
        }
    };

    const toggleMute = () => {
        if (!activeCallSessionRef.current?.sessionDescriptionHandler) return;
        try {
            const newMuteState = !isMuted;

            // During a merged conference the SENDER tracks are synthesized mixes
            // (IsMixedTrack). Disabling those would silence BOTH the agent and the
            // far party. Instead we gate the agent's real mic at its source — the
            // pristine tracks we stashed on merge — which flow into both mixers.
            if (isConfJoined) {
                [parentMicTrackRef.current, confMicTrackRef.current].forEach(t => {
                    if (t) t.enabled = !newMuteState;
                });
                // Belt-and-braces: also toggle any non-mixed audio senders on both
                // legs (covers the moment right after a track restore).
                [activeCallSessionRef.current, conferenceSessionRef.current].forEach(sess => {
                    const pc = sess?.sessionDescriptionHandler?.peerConnection;
                    if (!pc) return;
                    pc.getSenders()
                        .filter(s => s.track && s.track.kind === 'audio' && !s.track.IsMixedTrack)
                        .forEach(s => { s.track.enabled = !newMuteState; });
                });
                setIsMuted(newMuteState);
                return;
            }

            // Normal (2-party) path.
            const peerConnection = activeCallSessionRef.current.sessionDescriptionHandler.peerConnection;
            if (peerConnection) {
                peerConnection.getSenders()
                    .filter(s => s.track && s.track.kind === 'audio')
                    .forEach(s => { s.track.enabled = !newMuteState; });
                setIsMuted(newMuteState);
            }
        } catch (error) {
            console.error('Error toggling mute:', error);
        }
    };

    const toggleDTMF = () => {
        if (activeCallSessionRef.current) {
            const newDtmfState = !dtmfButtons;
            setDtmfButtons(newDtmfState);
            if (!newDtmfState) setDTMFValue('');
        }
    };

    const toggleHold = () => {
        try {
            if (!activeCallSessionRef.current) return;

            // A SIP re-INVITE hold renegotiates SDP, which would tear down the
            // replaceTrack()-swapped mixed audio. During a merged conference we
            // therefore emulate hold LOCALLY: disable the mixed sender tracks and
            // silence the far parties' inbound audio, without touching signaling.
            if (isConfJoined) {
                const newHoldState = !isHeld;
                [activeCallSessionRef.current, conferenceSessionRef.current].forEach(sess => {
                    const pc = sess?.sessionDescriptionHandler?.peerConnection;
                    if (!pc) return;
                    pc.getSenders()
                        .filter(s => s.track && s.track.kind === 'audio')
                        .forEach(s => { s.track.enabled = !newHoldState; });
                });
                // ✅ FIX: mute BOTH monitor elements on hold. remote-audio carries
                // party1, conference-audio carries party2 — silencing only one
                // would leave the agent still hearing the other while "on hold".
                const { remoteAudio, conferenceAudio } = setupMediaElements();
                if (remoteAudio) remoteAudio.muted = newHoldState;
                if (conferenceAudio) conferenceAudio.muted = newHoldState;
                setIsHeld(newHoldState);
                return;
            }

            const newHoldState = !isHeld;
            const options = { sessionDescriptionHandlerOptions: { hold: newHoldState } };
            activeCallSessionRef.current.invite(options)
                .then(() => console.log(newHoldState ? 'On hold' : 'Off hold'))
                .catch(e => console.error('Hold toggle failed:', e));
            setIsHeld(newHoldState);
        } catch (error) {
            console.error('Error toggling hold:', error);
        }
    };

    const sendDTMF = (tone) => {
        setDTMFValue(dTMFValue + tone);
        // While the conference panel is open and the child leg is live (dialing or
        // connected but not yet merged), the third party is the leg the agent is
        // actively working with — e.g. keying through the third party's IVR — so
        // DTMF goes there. Once merged (or no child), it goes to the parent call.
        const child = conferenceSessionRef.current;
        const targetSession =
            (!isConfJoined && child && child.state !== SessionState.Terminated && child.sessionDescriptionHandler)
                ? child
                : activeCallSessionRef.current;
        if (targetSession?.sessionDescriptionHandler) {
            try {
                targetSession.sessionDescriptionHandler.sendDtmf(tone);
            } catch (error) {
                console.error('Error sending DTMF tone:', error);
            }
        }
    };

    const forwardAttendedExternalCall = (destination) => {
        if (!activeCallSessionRef.current || !userAgentRef.current) return;
        if (!isHeld) toggleHold();
        let dialednumber;
        if (destination.length > 4) {
            const cleanedNumber = destination.replace(/\D/g, '');
            if (/^0\d{9}$/.test(cleanedNumber)) dialednumber = `254${cleanedNumber.substring(1)}`;
            else if (/^254\d{9}$/.test(cleanedNumber)) dialednumber = cleanedNumber;
            else dialednumber = destination.replace(/\s/g, '');
        } else {
            dialednumber = destination.replace(/\s/g, '');
        }
        setWarmTransferTarget(dialednumber);
        const Server_Url = sessionStorage.getItem('Server_Url');
        const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
        if (!target) { console.error('Invalid destination URI for warm transfer'); return; }
        const inviter = new Inviter(userAgentRef.current, target);
        setConsultationSession(inviter);
        inviter.invite({ sessionDescriptionHandlerOptions: { constraints: { audio: true, video: false } } })
            .then(() => {
                setIsInWarmTransfer(true);
                setConsultationSession(inviter);
                inviter.stateChange.addListener((state) => {
                    if (state === SessionState.Established) {
                        attachMediaStreams(inviter);
                        setIsConsultationReady(true);
                    }
                    if (state === SessionState.Terminated) {
                        setIsInWarmTransfer(false);
                        setIsConsultationReady(false);
                        setConsultationSession(null);
                        if (isHeld) toggleHold();
                    }
                });
            })
            .catch(error => {
                console.error('Error initiating consultation call:', error);
                setIsInWarmTransfer(false);
                setIsConsultationReady(false);
                if (isHeld) toggleHold();
            });
    };

    const completeWarmTransfer = () => {
        if (!activeCallSessionRef.current || !consultationSession) return;
        try {
            const Server_Url = sessionStorage.getItem('Server_Url');
            const target = UserAgent.makeURI(`sip:${warmTransferTarget}@${Server_Url}`);
            if (!target) { console.error('Invalid target for completing transfer'); return; }
            activeCallSessionRef.current.refer(target);
            if (consultationSession.state !== SessionState.Terminated) consultationSession.bye();
            setConsultationSession(null);
            setIsInWarmTransfer(false);
            setWarmTransferTarget('');
            handleDroppedCallUI();
        } catch (error) {
            console.error('Warm transfer failed:', error);
        }
    };

    const cancelWarmTransfer = () => {
        if (consultationSession) {
            try {
                if (consultationSession.state !== SessionState.Terminated) consultationSession.bye();
            } catch (error) {
                console.error('Error canceling consultation:', error);
            }
        }
        setConsultationSession(null);
        setIsInWarmTransfer(false);
        setWarmTransferTarget('');
        if (isHeld) toggleHold();
    };

    const forwardCall = (destination) => {
        if (destination) {
            let dialednumber;
            if (destination > 4) {
                const DialNumber = destination.replace(/\s/g, '');
                const cleanedNumber = DialNumber.replace(/\D/g, '');
                if (/^0\d{9}$/.test(cleanedNumber)) dialednumber = `254${cleanedNumber.substring(1)}`;
                else if (/^254\d{9}$/.test(cleanedNumber)) dialednumber = cleanedNumber;
                else dialednumber = DialNumber;
            } else {
                dialednumber = destination.replace(/\s/g, '');
            }
            if (activeCallSessionRef.current) {
                try {
                    const Server_Url = sessionStorage.getItem('Server_Url');
                    const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
                    if (!target) { console.error('Invalid destination URI for forwarding'); return; }
                    activeCallSessionRef.current.refer(target);
                } catch (error) {
                    console.error('Error forwarding call:', error);
                }
            }
        }
    };

    // ── Campaign ──────────────────────────────────────────────────────────────
    const fetchAllCampaignContacts = async () => {
        try {
            const batchSize = 200;
            let allContacts = [];
            const initialResponse = await api.get('/campaign/assigned', {
                params: { limit: batchSize, offset: 0, search: searchText || '' },
                headers: { Authorization: `Bearer ${authyToken}` },
            });
            allContacts = initialResponse.data.data;
            const totalContacts = initialResponse.data.total;
            if (allContacts.length < totalContacts) {
                const pagesNeeded = Math.ceil((totalContacts - batchSize) / batchSize);
                const remainingRequests = Array.from({ length: pagesNeeded }, (_, i) =>
                    api.get('/campaign/assigned', {
                        params: { limit: batchSize, offset: (i + 1) * batchSize, search: searchText || '' },
                        headers: { Authorization: `Bearer ${authyToken}` },
                    })
                );
                const responses = await Promise.all(remainingRequests);
                responses.forEach(res => { allContacts = [...allContacts, ...res.data.data]; });
            }
            return allContacts;
        } catch (error) {
            console.error('Error fetching campaign contacts:', error);
            return [];
        }
    };

    // ── Reset ALL campaign state to a known-clean slate ─────────────────────
    // Called before every start and after every stop/completion so a second
    // run never inherits stale index/guard/contact-list values from the first.
    const resetCampaignState = () => {
        if (campaignTimeoutRef.current) {
            clearTimeout(campaignTimeoutRef.current);
            campaignTimeoutRef.current = null;
        }
        campaignModeRef.current = false;
        campaignContactsRef.current = [];
        currentContactIndexRef.current = 0;
        setCurrentContactIndex(0);
        // Clear the completion latch so the NEXT campaign can run. Safe because
        // startCampaign re-enables campaignModeRef immediately after calling this.
        campaignDoneRef.current = false;
        // Neutral guard so a lingering timeout/advance can't fire against it
        callLoggedRef.current = { done: true, advanced: true, contactIndex: null };
        callEstablishedRef.current = false;
    };

    const startCampaign = async (contactListParam) => {
        // Prevent overlapping campaigns — the ref is synchronous, so it (not the
        // async campaignMode state) is what actually guards against re-entry.
        if (campaignModeRef.current) {
            console.warn('[Campaign] Already running — ignoring start');
            return;
        }
        // Start every run from a clean slate
        resetCampaignState();

        let contactList = contactListParam;
        if (!contactList) contactList = await fetchAllCampaignContacts();
        if (!contactList || contactList.length === 0) { console.warn('No contacts available.'); return; }
        setCampaignMode(true);
        campaignModeRef.current = true;
        setCampaignContacts(contactList);
        campaignContactsRef.current = contactList;
        setCurrentContactIndex(0);
        currentContactIndexRef.current = 0;
        dialNextContact(contactList, 0);
        setSelectedDailerTab(0);
    };

    const dialNextContact = (contactList, index) => {
        // If completion already ran (latched), never dial again — this stops a
        // stale timeout or duplicate end-event from re-dialing the last contact.
        if (campaignDoneRef.current && index < contactList.length) {
            return;
        }
        if (index >= contactList.length) {
            campaignDoneRef.current = true; // latch before teardown
            setCampaignMode(false);
            notifyAutoDialer(false);
            // Full teardown so the next run starts clean
            resetCampaignState();
            return;
        }
        const contact = contactList[index];
        const phoneNumber = contact.phone_number || contact.phone;
        setDialDisplay(phoneNumber);
        setDialerNumber(phoneNumber);
        setCurrentContactIndex(index);
        currentContactIndexRef.current = index;
        makeCall(phoneNumber);

        // ✅ FIX B: Clear any prior timeout before arming a new one, and make the
        // timeout hang up (which now advances internally) using THIS contact's guard.
        if (campaignTimeoutRef.current) clearTimeout(campaignTimeoutRef.current);

        // Capture the guard created by makeCall for this specific contact so the
        // timeout acts only on this call and not a later one.
        const guardForThisContact = callLoggedRef.current;

        campaignTimeoutRef.current = setTimeout(() => {
            // Only act if THIS contact's call is still unresolved and was never picked up
            if (guardForThisContact && !guardForThisContact.done && !callEstablishedRef.current) {
                // hangUpCallOutGoing sets guard.done, logs "No Answer", and advances
                hangUpCallOutGoing();
            }
        }, campaignTimeout * 1000);
    };

    const stopCampaign = () => {
        setDialDisplay('');
        setCampaignMode(false);
        notifyAutoDialer(false);
        resetCampaignState();
    };

    useEffect(() => {
        const fetchConfigsIfNeeded = async () => {
            const cachedWsServer = sessionStorage.getItem('WsServer');
            if (cachedWsServer) {
                setupSIPClient();
            } else {
                try {
                    setVoipSignalStatus('#1E90FF');
                    const response = await api.get('/user/usercallconfigs', {
                        headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
                        withCredentials: true,
                    });
                    sessionStorage.setItem('WsServer', response.data.wsServer);
                    sessionStorage.setItem('Extension', response.data.authorizationUser);
                    sessionStorage.setItem('ExtPass', response.data.extPass);
                    sessionStorage.setItem('Uri', response.data.Uri);
                    sessionStorage.setItem('Server_Url', response.data.Server_Url);
                    setupSIPClient();
                } catch (error) {
                    console.error('Error fetching configs:', error);
                    setVoipSignalStatus('#FF160C');
                }
            }
        };
        fetchConfigsIfNeeded();
        return () => {
            try { userAgentRef.current?.stop(); } catch (e) { console.error(e); }
            if (registrationTimeoutRef.current) clearTimeout(registrationTimeoutRef.current);
            if (connectivityCheckIntervalRef.current) clearInterval(connectivityCheckIntervalRef.current);
            if (statusCheckIntervalRef.current) clearInterval(statusCheckIntervalRef.current);
        };
    }, []);

    // ── Contact name lookup ───────────────────────────────────────────────────
    // Shared by incoming, outgoing (makeCall), live dial-pad typing, and paste.
    // Backend may return a single { name, phone_number } or { matches: [...] }.
    const contactLookupSeqRef = useRef(0);

    const clearContactMatch = () => {
        setContactName('');
        setMatchedContactPhone('');
        setContactMatches([]);
    };

    const handleContactName = async (dialednumber) => {
        if (!dialednumber) {
            clearContactMatch();
            return;
        }
        const seq = ++contactLookupSeqRef.current;
        try {
            let cleaned = String(dialednumber).replace(/\s/g, '');
            // Mirror makeCall normalization so search hits the same stored form
            const digits = cleaned.replace(/\D/g, '');
            if (/^0\d{9}$/.test(digits)) {
                cleaned = `254${digits.substring(1)}`;
            } else if (/^254\d{9}$/.test(digits) || /^256\d{9}$/.test(digits)) {
                cleaned = digits;
            } else if (/^\+\d+$/.test(cleaned)) {
                cleaned = cleaned;
            } else if (digits) {
                cleaned = digits;
            }
            // For name-typed queries keep original letters; for pure numbers use cleaned
            const hasLetters = /[a-zA-Z]/.test(String(dialednumber));
            const searchKey = hasLetters
                ? String(dialednumber).trim()
                : (cleaned.replace(/^(\+254|254|0)/, '') || cleaned);

            const response = await api.get(`/contact/contactsearch/${encodeURIComponent(searchKey)}`, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
                withCredentials: true,
            });

            if (seq !== contactLookupSeqRef.current) return;

            const data = response.data || {};
            // Prefer explicit matches[] from multi-result API; fall back to single object
            let list = Array.isArray(data.matches) ? data.matches : [];
            if (list.length === 0 && (data.name || data.phone_number || data.phone)) {
                list = [{
                    name: data.name || null,
                    phone_number: data.phone_number || data.phone || data.number || data.mobile || null,
                    alternative_phone_number: data.alternative_phone_number || null,
                    type: data.type || null,
                }];
            }

            // Flatten primary + alternative into separate tappable rows
            const flattened = [];
            for (const m of list) {
                const name = m?.name || null;
                if (m?.phone_number) {
                    flattened.push({
                        name,
                        phone_number: String(m.phone_number),
                        label: m.label || (m.alternative_phone_number ? 'Primary' : null),
                        type: m.type || null,
                    });
                }
                if (m?.alternative_phone_number) {
                    flattened.push({
                        name,
                        phone_number: String(m.alternative_phone_number),
                        label: m.label || 'Alt',
                        type: m.type || null,
                    });
                }
                // Name-only row (no phone) — still show, but not tappable for paste
                if (!m?.phone_number && !m?.alternative_phone_number && name) {
                    flattened.push({
                        name,
                        phone_number: cleaned || null,
                        label: null,
                        type: m.type || null,
                    });
                }
            }

            setContactMatches(flattened);
            setContactName(flattened[0]?.name || '');
            setMatchedContactPhone(flattened[0]?.phone_number || '');
        } catch (error) {
            if (seq === contactLookupSeqRef.current) {
                clearContactMatch();
            }
        }
    };

    // Click a match row → paste that full number into the dial field
    const applyMatchedContact = (phone) => {
        const number = phone || matchedContactPhone;
        if (!number) return;
        setDialDisplay(String(number));
        setMatchedContactPhone(String(number));
    };

    // Live lookup while keying digits / name / after paste into the dial field.
    // Debounced so we don't hit the API on every keystroke.
    useEffect(() => {
        const value = (dialdisplay || '').trim();
        if (!value) {
            clearContactMatch();
            return;
        }

        const digits = value.replace(/\D/g, '');
        const hasLetters = /[a-zA-Z]/.test(value);
        // Search once it looks useful: name text, extension, or full MSISDN
        const looksComplete =
            hasLetters ||
            digits.length >= 4 ||
            /^0\d{9}$/.test(digits) ||
            /^254\d{9}$/.test(digits) ||
            /^256\d{9}$/.test(digits) ||
            /^\+\d{8,}$/.test(value.replace(/\s/g, ''));

        if (!looksComplete) {
            clearContactMatch();
            return;
        }

        const timer = setTimeout(() => {
            handleContactName(value);
        }, 400);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dialdisplay]);

    const handleOpenAddDispositionModal = () => {
        setAddDispositionModal(true);
        fetchDispositionList();
        fetchDispositionCategory();
    };

    const handleCloseAddDispositionModal = () => {
        setAddDispositionModal(false);
        setDispositionContact('');
        setCallType('');
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewDisposition({ ...newDisposition, [name]: value });
    };

    const handleInputBreakChange = (event) => {
        const { value } = event.target;
        setBreakType(value);
        sessionStorage.removeItem('breakType');
        if (value) {
            setBreakDrop('none');
            setBreakBtn('');
            sessionStorage.setItem('breakType', value);
        }
        const authyToken = localStorage.getItem(authToken);
        const breakId = `break_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('break', breakId);
        api.post('/break/add', { break_id: breakId, break_type: value }, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => handleWebsocketTakeBreak())
            .catch((error) => {
                console.error('[Break] Failed to start break:', error);
                resetTime();
                setBreakDrop('');
                setBreakType('');
                setBreakBtn('none');
                sessionStorage.removeItem('break');
            });
    };

    const handleDispositionSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        api.post('/disposition/add', formData, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => setAddDispositionModal(false))
            .catch(console.error);
        setDispositionContact('');
        setCallType('');
    };

    const fetchDispositionList = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/disposition/list', {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setDispositionList(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Group:', error);
        }
    };

    const handleAddCallLog = async (duration, type, destination, source) => {
        const NON_ANSWERED = ['Missed', 'No Answer', 'Canceled', 'Rejected',
                              'Failed', 'Busy', 'Invalid Number', 'Forbidden', 'Timeout'];

        const snapshotDestination = type === 'outgoing'
            ? (dialedNumberRef.current ?? destination)
            : destination;

        const snapshotRecordingId = (duration && !NON_ANSWERED.includes(duration))
            ? (recording_call_id.current ?? null)
            : null;

        const snapshotContactName = contactName || '';

        if (!source || !snapshotDestination || !duration || !type) {
            console.warn('[CallLog] Missing required parameters — skipping log:',
                { duration, type, destination: snapshotDestination, source });
            return;
        }

        const params = {
            duration,
            type,
            destination: snapshotDestination,
            source,
            contactsavedname: snapshotContactName,
            ...(snapshotRecordingId !== null && { recording_id: snapshotRecordingId }),
        };

        const addCallToDatabase = async () => {
            try {
                const authyToken = localStorage.getItem(authToken);
                const response = await api.post('/call/add', params, {
                    headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
                    withCredentials: true,
                });
                updateCallLogsUpdate();
                return response;
            } catch (error) {
                console.error('[CallLog] API post failed:', error);
                throw error;
            }
        };

        if (duration === 'Picked') {
            const call_id = recording_call_id.current ?? '';
            startCall('incoming', call_id, source, snapshotDestination);
        }

        if (params.duration === 'Missed') {
            setTimeout(addCallToDatabase, 10000);
        } else {
            await addCallToDatabase();
            dialedNumberRef.current = null;
            updateCallLogsUpdate();
        }
    };

    useEffect(() => {
        return () => {
            resetTimer();
            handleContactName('');
            stopEndTone();
            stopIncomingTone();
            stopOutgoingTone();
        };
    }, []);

    const handleTakingBreakClose = () => {
        resetTime();
        setTakingBreakOpen(false);
        setBreakDrop('');
        setBreakType('');
        setBreakBtn('none');
        setTakeBreak(false);
        takeBreakRef.current = false;
        setAutoAnswer(false);
        autoAnswerRef.current = false;
        const breakId = sessionStorage.getItem('break');
        if (socketRef.current) {
            socketRef.current.emit('END_BREAK', { breakId });
            socketRef.current.emit('SEND_BREAK_UPDATE');
        }
        const authyToken = localStorage.getItem(authToken);
        api.post('/break/add', { break_id: breakId }, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => {
                resetTime();
                takeBreakRef.current = false;
                sessionStorage.removeItem('break');
            })
            .catch(console.error);
        resetTime();
    };

    const handleWebsocketTakeBreak = () => {
        if (!socketRef.current?.connected) {
            console.warn('[Break] Socket not connected, retrying in 1s');
            setTimeout(handleWebsocketTakeBreak, 1000);
            return;
        }
        const breakId = sessionStorage.getItem('break');
        const breakTypeValue = sessionStorage.getItem('breakType');
        socketRef.current.emit('START_BREAK', {
            breakId,
            breakType: breakTypeValue || 'General Break',
            timestamp: new Date().toISOString(),
        });
    };

    useEffect(() => {
        const sock = socketRef.current;
        if (!sock) return;
        const handleDropBreak = ({ breakId }) => {
            if (breakId === sessionStorage.getItem('break')) handleTakingBreakClose();
        };
        sock.on('NEW_DROP_BREAK', handleDropBreak);
        return () => sock.off('NEW_DROP_BREAK', handleDropBreak);
    }, []);

    const startCall = (callType, callId, callTo, callFrom) => {
        if (!socketRef.current) return;
        const isOutgoing = callType === 'outgoing';
        socketRef.current.emit('CALL_STARTED', {
            callType,
            callId,
            callTo: isOutgoing ? callFrom : callTo,
            callFrom: isOutgoing ? callTo : callFrom,
            agentName: sessionStorage.getItem('user_name'),
            status: 'active',
            startTime: new Date().toISOString(),
        });
    };

    const startCallOutGoing = () => {
        if (!socketRef.current) return;
        socketRef.current.emit('CALL_STARTED', {
            callType: 'outgoing',
            callId: recording_call_id.current ?? '',
            callTo: dialedNumberRef.current,
            callFrom: sessionStorage.getItem('extension'),
            agentName: sessionStorage.getItem('user_name'),
            status: 'active',
            startTime: new Date().toISOString(),
        });
    };

    const updateCallLogsUpdate = () => {
        updateCallsDataEvent();
        socketRef.current?.emit('SEND_CALL_LOG_UPDATE');
    };

    const endCall = () => {
        const callId = recording_call_id.current ?? '';
        if (!callId) { console.warn('No call ID provided'); return; }
        socketRef.current?.emit('END_CALL', { callId });
    };

    const fetchDispositionCategory = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/disposition/category', {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setDispositionCategory(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Category:', error);
        }
    };

    const handleShowSubCategoryDropdown = async (id) => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get(`/disposition/subcategory/${id}`, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setSubCategorDataDropDown(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Sub Category:', error);
        }
    };

    const handleInputCatChange = (event) => {
        const { value } = event.target;
        const selectedCategory = dispositionCategory.find(cat => cat.category === value);
        if (selectedCategory) handleShowSubCategoryDropdown(selectedCategory.id);
    };

    useEffect(() => {
        const handleCopyPhone = (event) => {
            const number = event.detail;
            setDialDisplay(number);
            setSelectedDailerTab(0);
            // Instant lookup on paste — the dialdisplay effect will also fire,
            // but this avoids waiting for the 400ms debounce when pasting a full number.
            if (number) handleContactName(number);
        };
        window.addEventListener('copyPhoneNumber', handleCopyPhone);
        return () => window.removeEventListener('copyPhoneNumber', handleCopyPhone);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateCallsDataEvent = () => {
        window.dispatchEvent(new CustomEvent('updateCallsDataEvent', { detail: 'callsDataEventActive' }));
    };

    const handleTransferSelect = (buttonType) => {
        setActiveTransferButton(buttonType);
        const actions = {
            'attended-internal': () => { setUnattendedInternalStatus(false); setTransferCalls(true); handleGetTransferToUsers(); },
            'unattended-internal': () => { setUnattendedInternalStatus(true); setTransferCalls(true); handleGetTransferToUsers(); },
            'attended-external': () => { setExternalAttendedTransferCalls(true); },
            'unattended-external': () => { setExternalTransferCalls(true); },
        };
        const action = actions[buttonType];
        if (action) action();
        else console.warn('Unknown button type:', buttonType);
    };

    const resetTransferSelection = () => {
        setActiveTransferButton(null);
        setExternalAttendedTransferCalls(false);
    };

    const notifyAutoDialer = (value) => {
        window.dispatchEvent(new CustomEvent('notifyAutoDialer', { detail: value ? '#FF9800' : 'inherit' }));
    };

    const handleRingtoneMuteToggle = () => {
        const newMuteState = !isRingtoneMuted;
        setIsRingtoneMuted(newMuteState);
        if (newMuteState) stopIncomingTone();
        else playIncomingTone();
    };

    // ── Online presence ───────────────────────────────────────────────────────
    useEffect(() => {
        if (!socket) return;
        const fetchPresence = async () => {
            try {
                const authyToken = localStorage.getItem(authToken);
                const headers = { Authorization: `Bearer ${authyToken}` };
                const decoded = jwtDecode(authyToken);
                const orgId = decoded.organization_id;
                const response = await api.get(`/presence/${orgId}`, { headers, withCredentials: true });
                const ids = new Set(response.data.map(u => String(u.userId)));
                setOnlineUsers(ids);
            } catch (err) {
                console.error('Failed to fetch presence:', err);
            }
        };
        fetchPresence();
        const handlePresence = ({ userId, status }) => {
            setOnlineUsers(prev => {
                const updated = new Set(prev);
                if (status === 'online') updated.add(String(userId));
                else updated.delete(String(userId));
                return updated;
            });
        };
        socket.on('USER_PRESENCE', handlePresence);
        return () => {
            socket.off('USER_PRESENCE', handlePresence);
        };
    }, [socket]);

    return (
        <Box sx={{ display: 'flex', }}>
            <CssBaseline />
            <Drawer
                sx={{
                    width: drawerWidth,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        zIndex: 1,
                    },
                }}
                variant="permanent"
                anchor="right"
                open={false}
                onClose={onClose}
            >
                <Toolbar />
                <Box sx={{width:'100%', borderBottom:`3px solid ${voipSignalStatus}`, marginTop:'-15px'}}></Box>

                {selectedDailerTab === 0 &&  <span>

                    {/* RECEIVING PHONE */}
                    <Grid container spacing={1} sx={{ display: showIncomingCall ? 'flex' : 'none', mb: 1 , p:4}}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>INCOMING CALL</Typography>
                                <span>  <IconButton sx={{color:'inherit',marginTop:'20px'}}>
                                    <ShakingRingVolumeIcon sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                                <span>
                                    <Typography sx={{fontSize: "23px;"}}>
                                        {contactName ? contactName : dialerNumber}
                                    </Typography>
                                </span>
                                <span>
                                    <Typography sx={{fontSize: "20px;"}}>
                                        {incomingNumber}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: hideCallButtonsAccept ? 'flex' : 'none', justifyContent: 'space-between', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.success.main} !important` ,
                                }}
                                onClick={acceptCallHandler}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>

                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={rejectCallHandler}
                            >
                                <PhoneDisabled sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={12} sx={{ display: RingtoneIcon ? 'flex':'none', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:"10px"}}>
                            <Divider/>
                            <Box>
                                <Typography>{isRingtoneMuted ? "Unmute" : "Mute"} Ringtone</Typography>
                                <IconButton onClick={handleRingtoneMuteToggle} aria-label={isRingtoneMuted ? "Unmute" : "Mute"}>
                                    {isRingtoneMuted ? <VolumeOff sx={{fontSize:'1.8rem'}}/> : <VolumeUp sx={{fontSize:'1.8rem'}}/>}
                                </IconButton>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span>
                                    <Typography sx={{fontSize: "15px;", fontWeight:"lighter"}}>
                                        {showConnecting}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>
                    </Grid>

                    {/* MAKING PHONE CALL */}
                    <Grid container spacing={1} sx={{ display: showMakingCall ? 'flex' : 'none', mb: 1 , p:4}}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>{isRinging}</Typography>
                                <span>  <IconButton sx={{color:'inherit'}}>
                                    <PermIdentity sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                                <span>
                                    <Typography sx={{fontSize: "23px;"}}>
                                        {contactName ? contactName : dialerNumber}
                                    </Typography>
                                </span>
                                <span>
                                    <Typography sx={{fontSize: "20px;"}}>
                                        {dialerNumber}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={hangUpCallOutGoing}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* ACTIVE CALL */}
                    <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, display: showacceptedCall ? 'flex' : 'none', justifyContent: 'center' }}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'40px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span>  <IconButton sx={{color:'inherit'}}>
                                    <PermIdentity sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'-10px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h5' sx={{marginTop:'20px', fontWeight:'bold'}}>{contactName ? contactName : dialerNumber}</Typography>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center",marginTop:'-10px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h5' sx={{marginTop:'20px'}}>{dialerNumber}</Typography>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'-15px!important', marginBottom:'15px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>{timer}</Typography>
                            </div>
                        </Grid>

                        {/* DTMF Buttons */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-20px!important', display: dtmfButtons ? 'flex':'none', justifyContent: 'center' }}>
                            <TextField
                                variant="outlined"
                                value={dTMFValue}
                                onChange={(event) => setDTMFValue(event.target.value)}
                                sx={{
                                    paddingLeft:"10px",
                                    paddingRight:"10px",
                                    paddingBottom: "-5px",
                                    fontSize: 20,
                                    textAlign:"center",
                                    "& .MuiInputBase-input": {
                                        textAlign: "center",
                                        fontWeight:"lighter",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        boxShadow: "none",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                }}
                                placeholder='DTMF Tone'
                            />
                            <Grid item xs={12} sx={{paddingBottom:'10px', marginTop:'-10px'}}><Divider/></Grid>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                                <Grid item xs={4} key={number} sx={{ textAlign: 'center', padding: '0px'}}>
                                    <Button
                                        sx={{
                                            width: '35px',
                                            height: '35px',
                                            borderRadius: '50%',
                                            minWidth: '35px',
                                            padding: 0,
                                            color: 'inherit',
                                            '&:hover': {
                                                borderRadius: '50%',
                                            },
                                        }}
                                        onClick={() => sendDTMF(number.toString())}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ fontSize: 20, marginTop: "-6px" }}>{number}</span>
                                        </div>
                                    </Button>
                                </Grid>
                            ))}

                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('*')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 25, marginTop:'10px'}}>*</span>
                                    </div>
                                </Button>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('0')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 20,}}>0</span>
                                    </div>
                                </Button>
                            </Grid>

                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('#')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 20}}>#</span>
                                    </div>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sx={{marginTop:'10px'}}><Divider/></Grid>
                        </Grid>

                        {/* Transfer Selection */}
                        <Grid container spacing={1} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: transferSelection ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid item xs={12} sx={{ textAlign: 'center', mb: 2}}>
                                <Typography variant="body2" color="warning.main">
                                    Transfer
                                </Typography>
                            </Grid>

                            <Grid container spacing={2}>
                                {(activeTransferButton === null || activeTransferButton === 'attended-internal') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="info" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('attended-internal')}>
                                            Attended (Internal)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'unattended-internal') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="primary" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('unattended-internal')}>
                                            Unattended (Internal)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'attended-external') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="success" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('attended-external')}>
                                            Attended (External)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'unattended-external') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="warning" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('unattended-external')}>
                                            Unattended (External)
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>

                            {isInWarmTransfer && (
                                <>
                                    <Grid item xs={6} sx={{ textAlign: 'center', padding: '5px' }}>
                                        <Button variant="outlined" color="success" fullWidth disabled={!isConsultationReady} onClick={completeWarmTransfer}>
                                            Complete
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'center', padding: '5px' }}>
                                        <Button variant="outlined" color="error" fullWidth sx={{fontWeight:'bold'}} onClick={cancelWarmTransfer}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </>
                            )}
                        </Grid>

                        {/* Transfer External Section */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: externalAttendedTransferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={11}>
                                    <TextField
                                        placeholder="Enter External Number"
                                        value={externalAttendedDisplay}
                                        onChange={(event) => setExternalAttendedDisplay(event.target.value)}
                                        sx={{
                                            color:"inherit",
                                            marginTop:"15px",
                                            paddingLeft:"10px",
                                            paddingRight:"10px",
                                            paddingBottom: "-5px",
                                            marginLeft: '-20px',
                                            fontSize: 20,
                                            "& .MuiInputBase-input": {
                                                fontWeight:"lighter",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                border: "none",
                                                boxShadow: "none",
                                            },
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            borderRadius: '0px 7px 7px 0px',
                                            marginLeft: '-30px',
                                            marginBottom: '-40px',
                                            marginTop:"15px",
                                            paddingBottom: "-5px",
                                            fontSize: 20,
                                        }}
                                        onClick={() => {forwardAttendedExternalCall(externalAttendedDisplay);}}
                                    >
                                        <Redo />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: externalTransferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={11}>
                                    <TextField
                                        placeholder="Enter External Number"
                                        value={externalDisplay}
                                        onChange={(event) => setExternalDisplay(event.target.value)}
                                        sx={{
                                            color:"inherit",
                                            marginTop:"15px",
                                            paddingLeft:"10px",
                                            paddingRight:"10px",
                                            paddingBottom: "-5px",
                                            marginLeft: '-20px',
                                            fontSize: 20,
                                            "& .MuiInputBase-input": {
                                                fontWeight:"lighter",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                border: "none",
                                                boxShadow: "none",
                                            },
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            borderRadius: '0px 7px 7px 0px',
                                            marginLeft: '-30px',
                                            marginBottom: '-40px',
                                            marginTop:"15px",
                                            paddingBottom: "-5px",
                                            fontSize: 20,
                                        }}
                                        onClick={() => {forwardCall(externalDisplay);}}
                                    >
                                        <Redo />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Transfer Internal Section */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-20px!important', display: transferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <TextField
                                fullWidth
                                select
                                label="Who to Transfer To"
                                placeholder="Who to Transfer To"
                                name="transfer_extn"
                                SelectProps={{
                                    displayEmpty: true,
                                }}
                                sx={{
                                    color:"inherit",
                                    marginTop:"15px",
                                    paddingLeft:"10px",
                                    paddingRight:"10px",
                                    paddingBottom: "-5px",
                                    fontSize: 20,
                                    textAlign:"center",
                                    "& .MuiInputBase-input": {
                                        textAlign: "center",
                                        fontWeight:"lighter",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        boxShadow: "none",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                }}
                                value={transferExtension}
                                onChange={handleTransferChange}
                                required
                            >
                                <MenuItem disabled selected> Who to Transfer Call To</MenuItem>
                                {transferToUsers.map((row, index) => (
                                    <MenuItem key={index} value={row.user_extension}>{row.user_name} - {row.user_extension}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Conference Dial Panel (3-party, browser-mixed) */}
                        <Grid container spacing={1} sx={{ pl:2, pr:2, pb:1, marginTop:'-10px!important', display: conferencePanel ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid item xs={12} sx={{ textAlign: 'center', mb: 1 }}>
                                <Typography variant="body2" color="warning.main" sx={{ fontWeight: 'bold' }}>
                                    Add to Call (Conference)
                                </Typography>
                                {conferenceStatus && (
                                    <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                                        {conferenceStatus}
                                    </Typography>
                                )}
                            </Grid>

                            <Grid container spacing={1} sx={{ alignItems: 'center' }}>
                                <Grid item xs={9}>
                                    <TextField
                                        placeholder="Number to add"
                                        value={conferenceDisplay}
                                        onChange={(event) => setConferenceDisplay(event.target.value)}
                                        disabled={isConfDialing || isConfReady}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-input": { fontWeight: "lighter", textAlign: "center" },
                                            "& .MuiOutlinedInput-root": { border: "none", boxShadow: "none" },
                                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={!conferenceDisplay || isConfDialing || isConfReady}
                                        onClick={() => conferenceDial(conferenceDisplay)}
                                        sx={{ minWidth: 0 }}
                                    >
                                        <Call sx={{ fontSize: '1.2rem' }} />
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                {(isConfDialing || isConfReady) && (
                                    <Grid item xs={6}>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            fullWidth
                                            sx={{ fontWeight: 'bold' }}
                                            onClick={cancelConferenceDial}
                                        >
                                            Drop
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item xs={(isConfDialing || isConfReady) ? 6 : 12}>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        fullWidth
                                        disabled={!isConfReady}
                                        sx={{ fontWeight: 'bold', color: 'inherit' }}
                                        onClick={joinConferenceCall}
                                    >
                                        Merge
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="text"
                                        color="inherit"
                                        fullWidth
                                        size="small"
                                        onClick={cancelConference}
                                    >
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* 3-WAY CONFERENCE active caption */}
                        {isConfJoined && (
                            <Grid item xs={12} sx={{ textAlign: 'center', mt: '-8px', mb: 1 }}>
                                <Typography variant="caption" sx={{ color: '#FF9800', fontWeight: 'bold', letterSpacing: '0.5px' }}>
                                    3-WAY CONFERENCE
                                </Typography>
                            </Grid>
                        )}

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleMute();}}
                            >
                                {isMuted ? <MicOff style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Mic sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleHold();}}
                            >
                                {isHeld ? <Pause style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <PlayArrow sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleTransferSelection();}}
                            >
                                {transferSelection ? <Redo style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Redo sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={handleOpenAddDispositionModal}
                            >
                                <NoteAlt sx={{ fontSize: '1.5rem', color: 'inherit' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {startConferenceCall();}}
                            >
                                <PeopleOutline
                                    sx={{
                                        fontSize: '1.5rem',
                                        color: isConfJoined ? '#FF9800' : (conferencePanel ? '#c62828' : 'inherit'),
                                    }}
                                />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => toggleDTMF()}
                            >
                                {dtmfButtons ? <Keyboard style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Keyboard sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={hangUpCall}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* DIALER BUTTONS */}
                    <TextField
                        variant="outlined"
                        value={dialdisplay}
                        onChange={(event) => setDialDisplay(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                if (isDialableNumber(dialdisplay)) {
                                    makeCall();
                                }
                            }
                        }}
                        sx={{
                            display: displayInput ? 'flex' : 'none',
                            paddingLeft:"10px",
                            paddingRight:"10px",
                            textAlign:"center",
                            "& .MuiInputBase-input": {
                                fontSize: "20px",
                                textAlign: "center",
                                fontWeight:"lighter",
                            },
                            "& .MuiOutlinedInput-root": {
                                border: "none",
                                boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                        placeholder='Enter Phone Number'
                    />

                    {/* Contact match list — under the number input; each row pastes its number */}
                    {displayInput && contactMatches.length > 0 && (
                        <Box
                            sx={{
                                mx: 1.5,
                                mt: 0.5,
                                mb: 0.75,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.75,
                                maxHeight: 180,
                                overflowY: 'auto',
                            }}
                        >
                            {contactMatches.map((m, i) => {
                                const canPaste = Boolean(m.phone_number);
                                return (
                                    <Box
                                        key={`${m.phone_number || m.name || 'm'}-${i}`}
                                        onClick={() => canPaste && applyMatchedContact(m.phone_number)}
                                        title={canPaste ? `Use ${m.phone_number}` : undefined}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            px: 1.5,
                                            py: 1.1,
                                            borderRadius: 2,
                                            cursor: canPaste ? 'pointer' : 'default',
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === 'dark'
                                                    ? 'rgba(33, 150, 243, 0.18)'
                                                    : 'rgba(33, 150, 243, 0.10)',
                                            border: '1px solid',
                                            borderColor: (theme) =>
                                                theme.palette.mode === 'dark'
                                                    ? 'rgba(33, 150, 243, 0.45)'
                                                    : 'rgba(33, 150, 243, 0.35)',
                                            transition: 'background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease',
                                            '&:hover': canPaste
                                                ? {
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === 'dark'
                                                            ? 'rgba(33, 150, 243, 0.28)'
                                                            : 'rgba(33, 150, 243, 0.18)',
                                                    borderColor: 'primary.main',
                                                    transform: 'translateY(-1px)',
                                                }
                                                : undefined,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '17px',
                                                fontWeight: 700,
                                                color: 'primary.main',
                                                lineHeight: 1.2,
                                                textAlign: 'center',
                                            }}
                                        >
                                            {m.name || 'Unknown'}
                                        </Typography>
                                        {m.phone_number && (
                                            <Typography
                                                sx={{
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    color: 'text.secondary',
                                                    mt: 0.3,
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {m.phone_number}
                                            </Typography>
                                        )}
                                        {canPaste && ('')}
                                    </Box>
                                );
                            })}
                        </Box>
                    )}

                    <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, display: dialerButtons ? 'flex':'none', justifyContent: 'center' }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                            <Grid item xs={4} key={number} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '40px',
                                        height: '65px',
                                        borderRadius: '100%',
                                        color: 'inherit',
                                    }}
                                    onClick={() => handleDialButtonClick(number.toString())}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 25, marginTop: number === 1 ? "-26px" : "-6px" }}>{number}</span>
                                        <span style={{ fontSize: 12, marginTop: "-10px" }}>
                                            {number === 1 ? "" : number === 2 ? "ABC" : number === 3 ? "DEF": number === 4 ? "GHI": number === 5 ? "JKL": number === 6 ? "MNO": number === 7 ? "PQRS": number === 8 ? "TUV": number === 9 ? "WXYZ" : ""}
                                        </span>
                                    </div>
                                </Button>
                            </Grid>
                        ))}

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('*')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 30}}>*</span>
                                </div>
                            </Button>
                        </Grid>
                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('0')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 25,}}>0</span>
                                </div>
                            </Button>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('#')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 25}}>#</span>
                                </div>
                            </Button>
                        </Grid>
                        <Grid item xs={12} sx={{ mb:'10px',textAlign: 'center' }}>
                            <Divider/>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('+')}
                            >
                                <AddIcon sx={{fontSize: '1.5rem'}}/>
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                disabled={!isDialableNumber(dialdisplay)}
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: isDialableNumber(dialdisplay)
                                        ? `${theme.palette.success.main} !important`
                                        : `${theme.palette.action.disabledBackground} !important`,
                                    opacity: isDialableNumber(dialdisplay) ? 1 : 0.45,
                                }}
                                onClick={() => makeCall()}
                            >
                                <Call sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    color:'inherit',
                                }}
                                onClick={() => handleButtonDelete()}
                            >
                                <BackspaceIcon sx={{fontSize: '1.5rem'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* Add Disposition Modal */}
                    <Modal
                        open={openAddDispositionModal}
                        onClose={handleCloseAddDispositionModal}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box sx={modalStyle}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <h3 id="modal-title">New Disposition</h3>
                                <Box display="flex" justifyContent="right">
                                    <Cancel onClick={handleCloseAddDispositionModal} sx={{ cursor: 'pointer' }} />
                                </Box>
                            </Box>
                            <form onSubmit={handleDispositionSubmit}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Disposition Contact"
                                            name="disposition_contact"
                                            onChange={(event) => setDispositionContact(event.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            required
                                            value={dispositionContact}
                                            sx={{marginTop:"5px"}}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Disposition Owner"
                                            placeholder="Disposition Owner"
                                            variant="outlined"
                                            fullWidth
                                            name="disposition_owner"
                                            required
                                            sx={{marginTop:"5px",display:'none'}}
                                            value={sessionStorage.getItem('extension')}
                                        />
                                        <TextField
                                            fullWidth
                                            select
                                            label="Call Type"
                                            name="call_type"
                                            sx={{marginTop:"5px"}}
                                            onChange={handleInputChange}
                                            required
                                            value={callType}
                                        >
                                            <MenuItem>Select Type Of Call</MenuItem>
                                            <MenuItem value="incoming">Incoming</MenuItem>
                                            <MenuItem value="outgoing">Outgoing</MenuItem>
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition Category"
                                            name="disposition_category"
                                            onChange={handleInputCatChange}
                                            sx={{marginTop:"5px"}}
                                        >
                                            <MenuItem disabled selected>Select Category</MenuItem>
                                            {dispositionCategory.map((row) => (
                                                <MenuItem key={row.id} value={row.category}>
                                                    {row.category}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition Sub Category"
                                            name="disposition_sub_category"
                                            onChange={handleInputChange}
                                            sx={{marginTop:"5px"}}
                                        >
                                            <MenuItem value="">Select Sub Category</MenuItem>
                                            {subCategorDataDropDown.map((row) => (
                                                <MenuItem key={row.id} value={row.sub_category}>
                                                    {row.sub_category}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition"
                                            name="disposition"
                                            sx={{marginTop:"5px"}}
                                            onChange={handleInputChange}
                                            required
                                            value={newDisposition.disposition}
                                        >
                                            <MenuItem value="">Select Disposition</MenuItem>
                                            <MenuItem value="Call Back">Call Back</MenuItem>
                                            {dispositionList.map((disposition, i) => (
                                                <MenuItem key={i} value={disposition.disposition_name}>{disposition.disposition_name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            multiline
                                            rows={2}
                                            label="Extra Info"
                                            placeholder="Extra Info"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                            fullWidth
                                            name="disposition_info"
                                            required
                                            sx={{marginTop:"5px"}}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Submit Disposition</Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button type="button" variant="contained" color='info' sx={{display:dispositionHangupButton, padding:"10px",marginTop:"10px",width:"100%",backgroundColor:"#c62828", color:'inherit'}} onClick={() => hangUpCall()}>Hang Up</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Box>
                    </Modal>
                </span>}

                {selectedDailerTab === 3 &&  <span>
                    <Box sx={{ height: "auto", overflowY: "auto"}}>
                        <Grid container spacing={2} sx={{p:4}}>
                            {sessionStorage.getItem("user_level") !== "agent" && (
                                <>
                                    <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Enable Call</Box></Grid>
                                    <Grid item xs={5} sx={{textAlign:"right"}}>
                                        <Switch checked={callEnabled} onChange={handleCallEnableChange} color="success" />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Take Break</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch checked={takeBreak} onChange={handleTakeBreakChange} disabled={autoAnswer} color="error" />
                            </Grid>

                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Auto Answer</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch checked={autoAnswer} onChange={handleAutoAnswerChange} disabled={takeBreak} color="info" />
                            </Grid>

                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px", color: flashSwitch ? 'warning.light' : 'inherit', transition: 'border-color 0.15s ease'}}> {campaignMode ? "Campaign On" : "Campaign Mode"}</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch
                                    checked={campaignMode}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        if (isChecked) {
                                            startCampaign();
                                            notifyAutoDialer(true);
                                        } else {
                                            stopCampaign();
                                            notifyAutoDialer(false);
                                        }
                                    }}
                                    color="warning"
                                    disabled={false}
                                />
                            </Grid>

                            {campaignMode && (
                                <Grid item xs={12}>
                                    <Divider/>
                                    <Typography variant="body2">
                                        Contact {currentContactIndex + 1} of {campaignContacts.length}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>

                        <Modal open={openTakingBreakModal} aria-labelledby="modal-title" aria-describedby="modal-description">
                            <Box sx={modalStyle}>
                                <div className="modal-content">
                                    <Box sx={{display: 'flex', justifyContent: 'center', width: '100%' }}>
                                        <h2 id="modal-title" sx={{textAlign:'center'}}>Break ( {timer} )</h2>
                                        <Box display="flex" justifyContent="right"></Box>
                                    </Box>
                                    <form>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    label="Break Type"
                                                    name="break_type"
                                                    sx={{marginTop:"10px", display: breakDrop}}
                                                    onChange={handleInputBreakChange}
                                                    required="true"
                                                >
                                                    <MenuItem disabled>Select</MenuItem>
                                                    <MenuItem value="Lunch Break">Lunch Break</MenuItem>
                                                    <MenuItem value="Short Break">Short Break</MenuItem>
                                                    <MenuItem value="Scheduled Break">Scheduled Break</MenuItem>
                                                    <MenuItem value="Team Meetings">Team Meetings</MenuItem>
                                                    <MenuItem value="Emergency Break">Emergency Break</MenuItem>
                                                    <MenuItem value="Rotational Break">Rotational Break</MenuItem>
                                                    <MenuItem value="Quiet Time Break">Quiet Time Break</MenuItem>
                                                </TextField>
                                                <Box sx={{display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <h1>{breakType}</h1>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Button type="button" variant="contained" color="success" sx={{padding:"10px", marginTop:"10px", color:'inherit', width:'100%', display: breakBtn}} onClick={() => handleTakingBreakClose(false)}>End Break</Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </div>
                            </Box>
                        </Modal>
                    </Box>
                </span>}

                {selectedDailerTab === 1 &&  <span>
                    <Box display='flex' sx={{ alignItems: 'center',alignContent: 'center', justifyContent: 'space-between',}}>
                        <TextField
                            variant="outlined"
                            sx={{
                                paddingLeft:"5px",
                                paddingRight:"5px",
                                textAlign:"center",
                                "& .MuiInputBase-input": {
                                    fontSize: "15px",
                                    textAlign: "center",
                                    fontWeight:"lighter",
                                },
                                "& .MuiOutlinedInput-root": {
                                    border: "none",
                                    boxShadow: "none",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                            }}
                            placeholder='Search Notification'
                        />
                        <Button variant="contained" color="error" sx={{marginRight:'5px'}}>Clear</Button>
                    </Box>
                </span>}

                {selectedDailerTab === 2 &&  <span>
                    <Grid container spacing={2} sx={{ p: 2 }}>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={() => startCampaign()} disabled={campaignMode}>
                                Start Campaign
                            </Button>
                        </Grid>

                        {campaignMode && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        Contact {currentContactIndex + 1} of {campaignContacts.length}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Button variant="contained" color="error" fullWidth onClick={stopCampaign}>
                                        Stop Campaign
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </span>}
                {selectedDailerTab === 5 &&  <span></span>}
                {selectedDailerTab === 6 &&  <span></span>}
            </Drawer>
            <audio id="local-audio" autoPlay muted></audio>
            <audio id="remote-audio" autoPlay></audio>
            <audio id="conference-audio" autoPlay></audio>
        </Box>
    );
};

export default DialBar;